export const taskData = [
  {
    "id": "522613122591096832",
    "taskCode": "TASK-20250409000795",
    "taskName": "供应商寻源",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "product_line",
    "bizLineName": "产品开发线",
    "bizStage": "02",
    "bizStageName": "设计",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2023-09-14T16:00:00.000+00:00",
    "planEndTime": "2023-10-13T16:00:00.000+00:00",
    "planWorkDay": 30,
    "realStartTime": "2023-09-15T00:00:00.000+00:00",
    "realEndTime": "2023-10-14T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630688100155392",
    "taskOwnerName": "剑峰（颜剑峰）",
    "taskStatus": "COMPLETED",
    "sortNo": 4,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [],
    "executors": [],
    "followers": [],
    "children": [
      {
        "id": "525059464483569664",
        "taskCode": "TASK-20250416000003",
        "taskName": "供应商选定",
        "description": null,
        "taskType": "NORMAL",
        "bizLine": "product_line",
        "bizLineName": "产品开发线",
        "bizStage": "02",
        "bizStageName": "设计",
        "keyTask": false,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": false,
        "planStartTime": "2023-09-14T16:00:00.000+00:00",
        "planEndTime": "2023-10-13T16:00:00.000+00:00",
        "planWorkDay": 30,
        "realStartTime": "2023-09-20T00:00:00.000+00:00",
        "realEndTime": "2023-09-30T00:00:00.000+00:00",
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630688100155392",
        "taskOwnerName": "剑峰（颜剑峰）",
        "taskStatus": "COMPLETED",
        "sortNo": 0,
        "comment": "OEM：川跃\n容器：大力\n",
        "color": "",
        "createdTime": "2025-04-16T03:44:01.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122591096832",
        "parentTaskName": "供应商寻源"
      },
      {
        "id": "525059464487763968",
        "taskCode": "TASK-20250416000004",
        "taskName": "包材供应商评估",
        "description": null,
        "taskType": "NORMAL",
        "bizLine": "product_line",
        "bizLineName": "产品开发线",
        "bizStage": "02",
        "bizStageName": "设计",
        "keyTask": false,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": false,
        "planStartTime": "2023-09-14T16:00:00.000+00:00",
        "planEndTime": "2023-10-13T16:00:00.000+00:00",
        "planWorkDay": 30,
        "realStartTime": "2023-09-15T00:00:00.000+00:00",
        "realEndTime": "2023-10-11T00:00:00.000+00:00",
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630840726683648",
        "taskOwnerName": "小丸子（丛爽）",
        "taskStatus": "COMPLETED",
        "sortNo": 1,
        "comment": "",
        "color": "",
        "createdTime": "2025-04-16T03:44:01.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122591096832",
        "parentTaskName": "供应商寻源"
      },
      {
        "id": "525059464487763969",
        "taskCode": "TASK-20250416000005",
        "taskName": "原料供应商评估",
        "description": null,
        "taskType": "NORMAL",
        "bizLine": "product_line",
        "bizLineName": "产品开发线",
        "bizStage": "02",
        "bizStageName": "设计",
        "keyTask": false,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": false,
        "planStartTime": "2023-09-14T16:00:00.000+00:00",
        "planEndTime": "2023-10-13T16:00:00.000+00:00",
        "planWorkDay": 30,
        "realStartTime": "2023-09-20T00:00:00.000+00:00",
        "realEndTime": "2023-09-29T00:00:00.000+00:00",
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630702750859264",
        "taskOwnerName": "花生（李青）",
        "taskStatus": "COMPLETED",
        "sortNo": 2,
        "comment": "",
        "color": "",
        "createdTime": "2025-04-16T03:44:01.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122591096832",
        "parentTaskName": "供应商寻源"
      },
      {
        "id": "525059464487763970",
        "taskCode": "TASK-20250416000006",
        "taskName": "配方供应商评估",
        "description": null,
        "taskType": "NORMAL",
        "bizLine": "product_line",
        "bizLineName": "产品开发线",
        "bizStage": "02",
        "bizStageName": "设计",
        "keyTask": false,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": false,
        "planStartTime": "2023-09-14T16:00:00.000+00:00",
        "planEndTime": "2023-10-13T16:00:00.000+00:00",
        "planWorkDay": 30,
        "realStartTime": "2023-09-11T00:00:00.000+00:00",
        "realEndTime": "2023-09-30T00:00:00.000+00:00",
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630702750859264",
        "taskOwnerName": "花生（李青）",
        "taskStatus": "COMPLETED",
        "sortNo": 3,
        "comment": "",
        "color": "",
        "createdTime": "2025-04-16T03:44:01.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122591096832",
        "parentTaskName": "供应商寻源"
      },
      {
        "id": "525059464487763971",
        "taskCode": "TASK-20250416000007",
        "taskName": "OEM供应商评估",
        "description": null,
        "taskType": "NORMAL",
        "bizLine": "product_line",
        "bizLineName": "产品开发线",
        "bizStage": "02",
        "bizStageName": "设计",
        "keyTask": false,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": false,
        "planStartTime": "2023-09-14T16:00:00.000+00:00",
        "planEndTime": "2023-10-13T16:00:00.000+00:00",
        "planWorkDay": 30,
        "realStartTime": "2023-09-26T00:00:00.000+00:00",
        "realEndTime": "2023-10-11T00:00:00.000+00:00",
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630688100155392",
        "taskOwnerName": "剑峰（颜剑峰）",
        "taskStatus": "COMPLETED",
        "sortNo": 4,
        "comment": "由于设备问题，oem加工厂只有川跃能满足",
        "color": "",
        "createdTime": "2025-04-16T03:44:01.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122591096832",
        "parentTaskName": "供应商寻源"
      }
    ],
    "childNum": 5,
    "childFinNum": 5,
    "allChildNum": 5,
    "allChildFinNum": 5,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096833",
    "taskCode": "TASK-20250409000796",
    "taskName": "确定供应商短名单",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "product_line",
    "bizLineName": "产品开发线",
    "bizStage": "02",
    "bizStageName": "设计",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2023-10-14T16:00:00.000+00:00",
    "planEndTime": "2023-11-12T16:00:00.000+00:00",
    "planWorkDay": 30,
    "realStartTime": "2023-10-16T00:00:00.000+00:00",
    "realEndTime": "2023-10-27T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630688100155392",
    "taskOwnerName": "剑峰（颜剑峰）",
    "taskStatus": "COMPLETED",
    "sortNo": 5,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [
      {
        "id": "522613123379625987",
        "taskId": "522613122591096832",
        "taskCode": "TASK-20250409000795",
        "taskName": "供应商寻源",
        "preRelateType": "FS"
      }
    ],
    "executors": [],
    "followers": [],
    "children": [
      {
        "id": "525059995520204800",
        "taskCode": "TASK-20250416000008",
        "taskName": "确定供应商短名单&引入",
        "description": null,
        "taskType": "NORMAL",
        "bizLine": "product_line",
        "bizLineName": "产品开发线",
        "bizStage": "02",
        "bizStageName": "设计",
        "keyTask": false,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": false,
        "planStartTime": "2023-10-14T16:00:00.000+00:00",
        "planEndTime": "2023-11-12T16:00:00.000+00:00",
        "planWorkDay": 30,
        "realStartTime": "2023-09-20T00:00:00.000+00:00",
        "realEndTime": "2023-09-26T00:00:00.000+00:00",
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630688100155392",
        "taskOwnerName": "剑峰（颜剑峰）",
        "taskStatus": "COMPLETED",
        "sortNo": 0,
        "comment": "OEM：川跃&蓓希颜\n容器：大力",
        "color": "",
        "createdTime": "2025-04-16T03:46:08.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122591096833",
        "parentTaskName": "确定供应商短名单"
      }
    ],
    "childNum": 1,
    "childFinNum": 1,
    "allChildNum": 1,
    "allChildFinNum": 1,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122586902530",
    "taskCode": "TASK-20250409000793",
    "taskName": "包装开发验证",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "product_line",
    "bizLineName": "产品开发线",
    "bizStage": "02",
    "bizStageName": "设计",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2023-12-16T16:00:00.000+00:00",
    "planEndTime": "2024-01-14T16:00:00.000+00:00",
    "planWorkDay": 30,
    "realStartTime": "2023-12-20T00:00:00.000+00:00",
    "realEndTime": "2024-01-17T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630464401145856",
    "taskOwnerName": "桃桃（杨婕）",
    "taskStatus": "COMPLETED",
    "sortNo": 2,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [],
    "executors": [],
    "followers": [],
    "children": [
      {
        "id": "525153714671976448",
        "taskCode": "TASK-20250416000026",
        "taskName": "包装开发验证（私模）",
        "description": "交付内容：1、包材验证计划制定；2、模具验证测试；3、初版包材规格书制定；4、兼容性测试；5、包材工艺性能测试；6、包材中试标准样；7、包材供应商质量批准8、验证报告（含评审）",
        "taskType": "NORMAL",
        "bizLine": "product_line",
        "bizLineName": "产品开发线",
        "bizStage": "02",
        "bizStageName": "设计",
        "keyTask": true,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": false,
        "planStartTime": "2023-12-16T16:00:00.000+00:00",
        "planEndTime": "2024-01-14T16:00:00.000+00:00",
        "planWorkDay": 30,
        "realStartTime": "2023-12-17T00:00:00.000+00:00",
        "realEndTime": "2024-01-12T00:00:00.000+00:00",
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630840726683648",
        "taskOwnerName": "小丸子（丛爽）",
        "taskStatus": "COMPLETED",
        "sortNo": 0,
        "comment": "",
        "color": "",
        "createdTime": "2025-04-16T09:58:33.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122586902530",
        "parentTaskName": "包装开发验证"
      }
    ],
    "childNum": 1,
    "childFinNum": 1,
    "allChildNum": 1,
    "allChildFinNum": 1,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122586902531",
    "taskCode": "TASK-20250409000794",
    "taskName": "灌装小试",
    "description": "交付内容：1、净含量、功能测试、跌落测试等；2、小试风险评估完善",
    "taskType": "NORMAL",
    "bizLine": "product_line",
    "bizLineName": "产品开发线",
    "bizStage": "02",
    "bizStageName": "设计",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-01-15T16:00:00.000+00:00",
    "planEndTime": "2024-04-16T16:00:00.000+00:00",
    "planWorkDay": 93,
    "realStartTime": "2024-01-16T00:00:00.000+00:00",
    "realEndTime": "2024-04-17T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630866412601344",
    "taskOwnerName": "元恺（钱峰）",
    "taskStatus": "COMPLETED",
    "sortNo": 3,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [
      {
        "id": "522613123379625985",
        "taskId": "522613122586902530",
        "taskCode": "TASK-20250409000793",
        "taskName": "包装开发验证",
        "preRelateType": "FS"
      },
      {
        "id": "522613123379625986",
        "taskId": "522613122586902528",
        "taskCode": "TASK-20250409000791",
        "taskName": "配方开发验证",
        "preRelateType": "FS"
      }
    ],
    "executors": [],
    "followers": [],
    "children": [
      {
        "id": "525508756386086919",
        "taskCode": "TASK-20250417000015",
        "taskName": "配方小试",
        "description": null,
        "taskType": "NORMAL",
        "bizLine": "product_line",
        "bizLineName": "产品开发线",
        "bizStage": "02",
        "bizStageName": "设计",
        "keyTask": false,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": false,
        "planStartTime": "2024-01-15T16:00:00.000+00:00",
        "planEndTime": "2024-04-03T16:00:00.000+00:00",
        "planWorkDay": 80,
        "realStartTime": "2024-01-16T00:00:00.000+00:00",
        "realEndTime": "2024-04-04T00:00:00.000+00:00",
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630209471348736",
        "taskOwnerName": "文俊（励文俊）",
        "taskStatus": "COMPLETED",
        "sortNo": 2,
        "comment": "",
        "color": "",
        "createdTime": "2025-04-17T09:29:21.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [],
        "executors": [],
        "followers": [],
        "children": [
          {
            "id": "525508756386086920",
            "taskCode": "TASK-20250417000016",
            "taskName": "自研配方小试",
            "description": null,
            "taskType": "NORMAL",
            "bizLine": "product_line",
            "bizLineName": "产品开发线",
            "bizStage": "02",
            "bizStageName": "设计",
            "keyTask": false,
            "keyLineTask": false,
            "milestoneTask": false,
            "milestoneNode": null,
            "controlTask": false,
            "planStartTime": "2024-01-15T16:00:00.000+00:00",
            "planEndTime": "2024-02-13T16:00:00.000+00:00",
            "planWorkDay": 30,
            "realStartTime": "2024-01-16T00:00:00.000+00:00",
            "realEndTime": "2024-02-14T00:00:00.000+00:00",
            "realWorkDay": null,
            "taskProgress": null,
            "taskOwnerId": "515630209471348736",
            "taskOwnerName": "文俊（励文俊）",
            "taskStatus": "COMPLETED",
            "sortNo": 0,
            "comment": "",
            "color": "",
            "createdTime": "2025-04-17T09:29:21.000+00:00",
            "projectId": "519255487028396032",
            "documentSecret": "L0",
            "oneProductOneDoc": false,
            "interfaceWithLaboratory": false,
            "spuList": [],
            "lockTasks": [],
            "preTasks": [],
            "executors": [],
            "followers": [],
            "children": [],
            "childNum": 0,
            "childFinNum": 0,
            "allChildNum": 0,
            "allChildFinNum": 0,
            "forms": null,
            "docs": null,
            "parentId": "525508756386086919",
            "parentTaskName": "配方小试"
          },
          {
            "id": "525508756386086922",
            "taskCode": "TASK-20250417000018",
            "taskName": "性能测试",
            "description": "交付内容：1、稳定性；2、防腐挑战；3、料体检测（防腐剂、重金属、风险物质、功效物质，如防晒剂、理化检测等）",
            "taskType": "NORMAL",
            "bizLine": "product_line",
            "bizLineName": "产品开发线",
            "bizStage": "02",
            "bizStageName": "设计",
            "keyTask": false,
            "keyLineTask": false,
            "milestoneTask": false,
            "milestoneNode": null,
            "controlTask": false,
            "planStartTime": "2024-01-15T16:00:00.000+00:00",
            "planEndTime": "2024-03-14T16:00:00.000+00:00",
            "planWorkDay": 60,
            "realStartTime": "2024-01-16T00:00:00.000+00:00",
            "realEndTime": "2024-03-15T00:00:00.000+00:00",
            "realWorkDay": null,
            "taskProgress": null,
            "taskOwnerId": "515630209471348736",
            "taskOwnerName": "文俊（励文俊）",
            "taskStatus": "COMPLETED",
            "sortNo": 2,
            "comment": "",
            "color": "",
            "createdTime": "2025-04-17T09:29:21.000+00:00",
            "projectId": "519255487028396032",
            "documentSecret": "L0",
            "oneProductOneDoc": false,
            "interfaceWithLaboratory": false,
            "spuList": [],
            "lockTasks": [],
            "preTasks": [],
            "executors": [],
            "followers": [],
            "children": [],
            "childNum": 0,
            "childFinNum": 0,
            "allChildNum": 0,
            "allChildFinNum": 0,
            "forms": null,
            "docs": null,
            "parentId": "525508756386086919",
            "parentTaskName": "配方小试"
          },
          {
            "id": "525508756386086923",
            "taskCode": "TASK-20250417000019",
            "taskName": "评估配方风险",
            "description": null,
            "taskType": "NORMAL",
            "bizLine": "product_line",
            "bizLineName": "产品开发线",
            "bizStage": "02",
            "bizStageName": "设计",
            "keyTask": false,
            "keyLineTask": false,
            "milestoneTask": false,
            "milestoneNode": null,
            "controlTask": false,
            "planStartTime": "2024-02-14T16:00:00.000+00:00",
            "planEndTime": "2024-02-23T16:00:00.000+00:00",
            "planWorkDay": 10,
            "realStartTime": "2024-02-15T00:00:00.000+00:00",
            "realEndTime": "2024-02-24T00:00:00.000+00:00",
            "realWorkDay": null,
            "taskProgress": null,
            "taskOwnerId": "515630812515794944",
            "taskOwnerName": "元素（彭绍远）",
            "taskStatus": "COMPLETED",
            "sortNo": 3,
            "comment": "",
            "color": "",
            "createdTime": "2025-04-17T09:29:21.000+00:00",
            "projectId": "519255487028396032",
            "documentSecret": "L0",
            "oneProductOneDoc": false,
            "interfaceWithLaboratory": false,
            "spuList": [],
            "lockTasks": [],
            "preTasks": [
              {
                "id": "525508757224947712",
                "taskId": "525508756386086920",
                "taskCode": "TASK-20250417000016",
                "taskName": "自研配方小试",
                "preRelateType": "FS"
              }
            ],
            "executors": [],
            "followers": [],
            "children": [],
            "childNum": 0,
            "childFinNum": 0,
            "allChildNum": 0,
            "allChildFinNum": 0,
            "forms": null,
            "docs": null,
            "parentId": "525508756386086919",
            "parentTaskName": "配方小试"
          },
          {
            "id": "525508756386086924",
            "taskCode": "TASK-20250417000020",
            "taskName": "整理料体半成品规格书",
            "description": "交付内容：1、半成品规格书；2、半成品标样",
            "taskType": "NORMAL",
            "bizLine": "product_line",
            "bizLineName": "产品开发线",
            "bizStage": "02",
            "bizStageName": "设计",
            "keyTask": false,
            "keyLineTask": false,
            "milestoneTask": false,
            "milestoneNode": null,
            "controlTask": false,
            "planStartTime": "2024-02-14T16:00:00.000+00:00",
            "planEndTime": "2024-02-23T16:00:00.000+00:00",
            "planWorkDay": 10,
            "realStartTime": "2024-02-15T00:00:00.000+00:00",
            "realEndTime": "2024-02-24T00:00:00.000+00:00",
            "realWorkDay": null,
            "taskProgress": null,
            "taskOwnerId": "515630209471348736",
            "taskOwnerName": "文俊（励文俊）",
            "taskStatus": "COMPLETED",
            "sortNo": 4,
            "comment": "",
            "color": "",
            "createdTime": "2025-04-17T09:29:21.000+00:00",
            "projectId": "519255487028396032",
            "documentSecret": "L0",
            "oneProductOneDoc": false,
            "interfaceWithLaboratory": false,
            "spuList": [],
            "lockTasks": [],
            "preTasks": [
              {
                "id": "525508757224947714",
                "taskId": "525508756386086920",
                "taskCode": "TASK-20250417000016",
                "taskName": "自研配方小试",
                "preRelateType": "FS"
              }
            ],
            "executors": [],
            "followers": [],
            "children": [],
            "childNum": 0,
            "childFinNum": 0,
            "allChildNum": 0,
            "allChildFinNum": 0,
            "forms": null,
            "docs": null,
            "parentId": "525508756386086919",
            "parentTaskName": "配方小试"
          }
        ],
        "childNum": 4,
        "childFinNum": 4,
        "allChildNum": 4,
        "allChildFinNum": 4,
        "forms": null,
        "docs": null,
        "parentId": "522613122586902531",
        "parentTaskName": "灌装小试"
      },
      {
        "id": "525508756386086913",
        "taskCode": "TASK-20250417000009",
        "taskName": "包材小试",
        "description": null,
        "taskType": "NORMAL",
        "bizLine": "product_line",
        "bizLineName": "产品开发线",
        "bizStage": "02",
        "bizStageName": "设计",
        "keyTask": true,
        "keyLineTask": false,
        "milestoneTask": true,
        "milestoneNode": null,
        "controlTask": false,
        "planStartTime": "2024-01-15T16:00:00.000+00:00",
        "planEndTime": "2024-04-13T16:00:00.000+00:00",
        "planWorkDay": 90,
        "realStartTime": "2024-01-16T00:00:00.000+00:00",
        "realEndTime": "2024-04-12T00:00:00.000+00:00",
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630840726683648",
        "taskOwnerName": "小丸子（丛爽）",
        "taskStatus": "COMPLETED",
        "sortNo": 1,
        "comment": "",
        "color": "",
        "createdTime": "2025-04-17T09:29:21.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [],
        "executors": [],
        "followers": [],
        "children": [
          {
            "id": "525508756386086918",
            "taskCode": "TASK-20250417000014",
            "taskName": "制定辅包规格书",
            "description": "交付内容：1、规格书",
            "taskType": "NORMAL",
            "bizLine": "product_line",
            "bizLineName": "产品开发线",
            "bizStage": "02",
            "bizStageName": "设计",
            "keyTask": false,
            "keyLineTask": false,
            "milestoneTask": false,
            "milestoneNode": null,
            "controlTask": false,
            "planStartTime": "2024-01-15T16:00:00.000+00:00",
            "planEndTime": "2024-01-15T16:00:00.000+00:00",
            "planWorkDay": 1,
            "realStartTime": "2024-01-16T00:00:00.000+00:00",
            "realEndTime": "2024-01-16T00:00:00.000+00:00",
            "realWorkDay": null,
            "taskProgress": null,
            "taskOwnerId": "515630109021962240",
            "taskOwnerName": "山木（严水荣）",
            "taskStatus": "COMPLETED",
            "sortNo": 4,
            "comment": "",
            "color": "",
            "createdTime": "2025-04-17T09:29:21.000+00:00",
            "projectId": "519255487028396032",
            "documentSecret": "L0",
            "oneProductOneDoc": false,
            "interfaceWithLaboratory": false,
            "spuList": [],
            "lockTasks": [],
            "preTasks": [],
            "executors": [],
            "followers": [],
            "children": [],
            "childNum": 0,
            "childFinNum": 0,
            "allChildNum": 0,
            "allChildFinNum": 0,
            "forms": null,
            "docs": null,
            "parentId": "525508756386086913",
            "parentTaskName": "包材小试"
          },
          {
            "id": "525508756386086917",
            "taskCode": "TASK-20250417000013",
            "taskName": "制作主包规格书",
            "description": "交付内容：1、规格书",
            "taskType": "NORMAL",
            "bizLine": "product_line",
            "bizLineName": "产品开发线",
            "bizStage": "02",
            "bizStageName": "设计",
            "keyTask": false,
            "keyLineTask": false,
            "milestoneTask": false,
            "milestoneNode": null,
            "controlTask": false,
            "planStartTime": "2024-01-15T16:00:00.000+00:00",
            "planEndTime": "2024-01-15T16:00:00.000+00:00",
            "planWorkDay": 1,
            "realStartTime": "2024-02-15T00:00:00.000+00:00",
            "realEndTime": "2024-02-23T00:00:00.000+00:00",
            "realWorkDay": null,
            "taskProgress": null,
            "taskOwnerId": "515630840726683648",
            "taskOwnerName": "小丸子（丛爽）",
            "taskStatus": "COMPLETED",
            "sortNo": 3,
            "comment": "",
            "color": "",
            "createdTime": "2025-04-17T09:29:21.000+00:00",
            "projectId": "519255487028396032",
            "documentSecret": "L0",
            "oneProductOneDoc": false,
            "interfaceWithLaboratory": false,
            "spuList": [],
            "lockTasks": [],
            "preTasks": [],
            "executors": [],
            "followers": [],
            "children": [],
            "childNum": 0,
            "childFinNum": 0,
            "allChildNum": 0,
            "allChildFinNum": 0,
            "forms": null,
            "docs": null,
            "parentId": "525508756386086913",
            "parentTaskName": "包材小试"
          },
          {
            "id": "525508756386086916",
            "taskCode": "TASK-20250417000012",
            "taskName": "主包标样确认&小试评估",
            "description": "交付内容：1、小试评估书",
            "taskType": "NORMAL",
            "bizLine": "product_line",
            "bizLineName": "产品开发线",
            "bizStage": "02",
            "bizStageName": "设计",
            "keyTask": false,
            "keyLineTask": false,
            "milestoneTask": false,
            "milestoneNode": null,
            "controlTask": false,
            "planStartTime": "2024-01-15T16:00:00.000+00:00",
            "planEndTime": "2024-01-16T16:00:00.000+00:00",
            "planWorkDay": 2,
            "realStartTime": "2025-04-22T00:00:00.000+00:00",
            "realEndTime": "2025-04-30T00:00:00.000+00:00",
            "realWorkDay": null,
            "taskProgress": null,
            "taskOwnerId": "515630840726683648",
            "taskOwnerName": "小丸子（丛爽）",
            "taskStatus": "COMPLETED",
            "sortNo": 2,
            "comment": "",
            "color": "",
            "createdTime": "2025-04-17T09:29:21.000+00:00",
            "projectId": "519255487028396032",
            "documentSecret": "L0",
            "oneProductOneDoc": false,
            "interfaceWithLaboratory": false,
            "spuList": [],
            "lockTasks": [],
            "preTasks": [],
            "executors": [],
            "followers": [],
            "children": [],
            "childNum": 0,
            "childFinNum": 0,
            "allChildNum": 0,
            "allChildFinNum": 0,
            "forms": null,
            "docs": null,
            "parentId": "525508756386086913",
            "parentTaskName": "包材小试"
          },
          {
            "id": "525508756386086915",
            "taskCode": "TASK-20250417000011",
            "taskName": "主包标样确认",
            "description": null,
            "taskType": "NORMAL",
            "bizLine": "product_line",
            "bizLineName": "产品开发线",
            "bizStage": "02",
            "bizStageName": "设计",
            "keyTask": false,
            "keyLineTask": false,
            "milestoneTask": false,
            "milestoneNode": null,
            "controlTask": false,
            "planStartTime": "2024-01-15T16:00:00.000+00:00",
            "planEndTime": "2024-01-17T16:00:00.000+00:00",
            "planWorkDay": 3,
            "realStartTime": "2024-02-24T00:00:00.000+00:00",
            "realEndTime": "2024-02-24T00:00:00.000+00:00",
            "realWorkDay": null,
            "taskProgress": null,
            "taskOwnerId": "515630840726683648",
            "taskOwnerName": "小丸子（丛爽）",
            "taskStatus": "COMPLETED",
            "sortNo": 1,
            "comment": "",
            "color": "",
            "createdTime": "2025-04-17T09:29:21.000+00:00",
            "projectId": "519255487028396032",
            "documentSecret": "L0",
            "oneProductOneDoc": false,
            "interfaceWithLaboratory": false,
            "spuList": [],
            "lockTasks": [],
            "preTasks": [],
            "executors": [
              {
                "id": "525508757115895811",
                "memberId": "515630464401145856",
                "memberName": "桃桃（杨婕）",
                "memberRole": "EXECUTOR",
                "mainRole": true
              },
              {
                "id": "525508757120090112",
                "memberId": "515630708518027264",
                "memberName": "刘也（刘凯豪）",
                "memberRole": "EXECUTOR",
                "mainRole": true
              },
              {
                "id": "525508757120090113",
                "memberId": "515630454364176384",
                "memberName": "阿冰（何冬生）",
                "memberRole": "EXECUTOR",
                "mainRole": true
              }
            ],
            "followers": [],
            "children": [],
            "childNum": 0,
            "childFinNum": 0,
            "allChildNum": 0,
            "allChildFinNum": 0,
            "forms": null,
            "docs": null,
            "parentId": "525508756386086913",
            "parentTaskName": "包材小试"
          },
          {
            "id": "525508756386086914",
            "taskCode": "TASK-20250417000010",
            "taskName": "主包测试&兼容稳定测试",
            "description": "交付内容：1、检验报告",
            "taskType": "NORMAL",
            "bizLine": "product_line",
            "bizLineName": "产品开发线",
            "bizStage": "02",
            "bizStageName": "设计",
            "keyTask": true,
            "keyLineTask": false,
            "milestoneTask": true,
            "milestoneNode": null,
            "controlTask": false,
            "planStartTime": "2024-01-15T16:00:00.000+00:00",
            "planEndTime": "2024-04-13T16:00:00.000+00:00",
            "planWorkDay": 90,
            "realStartTime": "2024-02-15T00:00:00.000+00:00",
            "realEndTime": "2024-02-23T00:00:00.000+00:00",
            "realWorkDay": null,
            "taskProgress": null,
            "taskOwnerId": "515630840726683648",
            "taskOwnerName": "小丸子（丛爽）",
            "taskStatus": "COMPLETED",
            "sortNo": 0,
            "comment": "",
            "color": "",
            "createdTime": "2025-04-17T09:29:21.000+00:00",
            "projectId": "519255487028396032",
            "documentSecret": "L0",
            "oneProductOneDoc": false,
            "interfaceWithLaboratory": false,
            "spuList": [],
            "lockTasks": [],
            "preTasks": [],
            "executors": [],
            "followers": [],
            "children": [],
            "childNum": 0,
            "childFinNum": 0,
            "allChildNum": 0,
            "allChildFinNum": 0,
            "forms": null,
            "docs": null,
            "parentId": "525508756386086913",
            "parentTaskName": "包材小试"
          }
        ],
        "childNum": 5,
        "childFinNum": 5,
        "allChildNum": 5,
        "allChildFinNum": 5,
        "forms": null,
        "docs": null,
        "parentId": "522613122586902531",
        "parentTaskName": "灌装小试"
      },
      {
        "id": "525508756386086912",
        "taskCode": "TASK-20250417000008",
        "taskName": "发起小试需求",
        "description": null,
        "taskType": "NORMAL",
        "bizLine": "product_line",
        "bizLineName": "产品开发线",
        "bizStage": "02",
        "bizStageName": "设计",
        "keyTask": false,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": false,
        "planStartTime": "2024-01-15T16:00:00.000+00:00",
        "planEndTime": "2024-01-16T16:00:00.000+00:00",
        "planWorkDay": 2,
        "realStartTime": "2024-01-08T00:00:00.000+00:00",
        "realEndTime": "2024-01-17T00:00:00.000+00:00",
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630464401145856",
        "taskOwnerName": "桃桃（杨婕）",
        "taskStatus": "COMPLETED",
        "sortNo": 0,
        "comment": "",
        "color": "",
        "createdTime": "2025-04-17T09:29:21.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122586902531",
        "parentTaskName": "灌装小试"
      },
      {
        "id": "525508756386086927",
        "taskCode": "TASK-20250417000023",
        "taskName": "确定质量规格书",
        "description": "交付内容：1、成品质量规格书",
        "taskType": "NORMAL",
        "bizLine": "product_line",
        "bizLineName": "产品开发线",
        "bizStage": "02",
        "bizStageName": "设计",
        "keyTask": false,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": false,
        "planStartTime": "2024-04-15T16:00:00.000+00:00",
        "planEndTime": "2024-04-16T16:00:00.000+00:00",
        "planWorkDay": 2,
        "realStartTime": "2024-04-16T00:00:00.000+00:00",
        "realEndTime": "2024-04-17T00:00:00.000+00:00",
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630812515794944",
        "taskOwnerName": "元素（彭绍远）",
        "taskStatus": "COMPLETED",
        "sortNo": 5,
        "comment": "",
        "color": "",
        "createdTime": "2025-04-17T09:29:21.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122586902531",
        "parentTaskName": "灌装小试"
      },
      {
        "id": "525508756386086925",
        "taskCode": "TASK-20250417000021",
        "taskName": "标样确认&小试评审",
        "description": "交付内容：1、风险评估表",
        "taskType": "TR",
        "bizLine": "product_line",
        "bizLineName": "产品开发线",
        "bizStage": "02",
        "bizStageName": "设计",
        "keyTask": true,
        "keyLineTask": false,
        "milestoneTask": true,
        "milestoneNode": null,
        "controlTask": false,
        "planStartTime": "2024-04-16T16:00:00.000+00:00",
        "planEndTime": "2024-04-16T16:00:00.000+00:00",
        "planWorkDay": 1,
        "realStartTime": "2024-04-17T00:00:00.000+00:00",
        "realEndTime": "2024-04-17T00:00:00.000+00:00",
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630812515794944",
        "taskOwnerName": "元素（彭绍远）",
        "taskStatus": "COMPLETED",
        "sortNo": 3,
        "comment": "",
        "color": "",
        "createdTime": "2025-04-17T09:29:21.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [
          {
            "id": "525508757229142016",
            "taskId": "522613122586902531",
            "taskCode": "TASK-20250409000794",
            "taskName": "灌装小试",
            "preRelateType": "FS"
          }
        ],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122586902531",
        "parentTaskName": "灌装小试"
      },
      {
        "id": "525508756386086926",
        "taskCode": "TASK-20250417000022",
        "taskName": "主数据录入",
        "description": null,
        "taskType": "NORMAL",
        "bizLine": "product_line",
        "bizLineName": "产品开发线",
        "bizStage": "02",
        "bizStageName": "设计",
        "keyTask": true,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": false,
        "planStartTime": "2024-04-16T16:00:00.000+00:00",
        "planEndTime": "2024-04-16T16:00:00.000+00:00",
        "planWorkDay": 1,
        "realStartTime": "2024-04-17T00:00:00.000+00:00",
        "realEndTime": "2024-04-17T00:00:00.000+00:00",
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630464401145856",
        "taskOwnerName": "桃桃（杨婕）",
        "taskStatus": "COMPLETED",
        "sortNo": 4,
        "comment": "",
        "color": "",
        "createdTime": "2025-04-17T09:29:21.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [
          {
            "id": "525508757229142017",
            "taskId": "522613122586902531",
            "taskCode": "TASK-20250409000794",
            "taskName": "灌装小试",
            "preRelateType": "FS"
          }
        ],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122586902531",
        "parentTaskName": "灌装小试"
      }
    ],
    "childNum": 6,
    "childFinNum": 6,
    "allChildNum": 15,
    "allChildFinNum": 15,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "525514392243011590",
    "taskCode": "TASK-20250409001291",
    "taskName": "原料准入",
    "description": "交付内容：1、原料检测报告；2、原料规格书",
    "taskType": "NORMAL",
    "bizLine": "product_line",
    "bizLineName": "产品开发线",
    "bizStage": "02",
    "bizStageName": "设计",
    "keyTask": false,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": false,
    "planStartTime": "2024-03-31T16:00:00.000+00:00",
    "planEndTime": "2024-08-29T16:00:00.000+00:00",
    "planWorkDay": 240,
    "realStartTime": "2024-04-01T00:00:00.000+00:00",
    "realEndTime": "2024-08-30T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630209471348736",
    "taskOwnerName": "文俊（励文俊）",
    "taskStatus": "COMPLETED",
    "sortNo": 1,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122586902528",
    "taskCode": "TASK-20250409000791",
    "taskName": "配方开发验证",
    "description": "交付内容：1、稳定性；2、防腐挑战；3、料体检测（防腐剂、重金属、风险物质、功效物质，如防晒剂、理化检测等）；4、制定半成品标准样",
    "taskType": "NORMAL",
    "bizLine": "product_line",
    "bizLineName": "产品开发线",
    "bizStage": "02",
    "bizStageName": "设计",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-03-31T16:00:00.000+00:00",
    "planEndTime": "2024-06-28T16:00:00.000+00:00",
    "planWorkDay": 90,
    "realStartTime": "2024-03-30T00:00:00.000+00:00",
    "realEndTime": "2025-06-27T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630464401145856",
    "taskOwnerName": "桃桃（杨婕）",
    "taskStatus": "COMPLETED",
    "sortNo": 0,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591097008",
    "taskCode": "TASK-20250409001271",
    "taskName": "TR2-B",
    "description": null,
    "taskType": "TR",
    "bizLine": "product_line",
    "bizLineName": "产品开发线",
    "bizStage": "02",
    "bizStageName": "设计",
    "keyTask": false,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": false,
    "planStartTime": "2024-04-17T16:00:00.000+00:00",
    "planEndTime": "2024-04-17T16:00:00.000+00:00",
    "planWorkDay": 1,
    "realStartTime": "2024-04-18T00:00:00.000+00:00",
    "realEndTime": "2024-04-18T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630812515794944",
    "taskOwnerName": "元素（彭绍远）",
    "taskStatus": "COMPLETED",
    "sortNo": 15,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [
      {
        "id": "524776353954791434",
        "taskId": "522613122586902530",
        "taskCode": "TASK-20250409000793",
        "taskName": "包装开发验证",
        "preRelateType": "FS"
      },
      {
        "id": "524776353954791435",
        "taskId": "522613122586902528",
        "taskCode": "TASK-20250409000791",
        "taskName": "配方开发验证",
        "preRelateType": "FS"
      },
      {
        "id": "524776353954791436",
        "taskId": "522613122586902531",
        "taskCode": "TASK-20250409000794",
        "taskName": "灌装小试",
        "preRelateType": "FS"
      }
    ],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122586902529",
    "taskCode": "TASK-20250409000792",
    "taskName": "产品包装设计",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "product_line",
    "bizLineName": "产品开发线",
    "bizStage": "02",
    "bizStageName": "设计",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-07-29T16:00:00.000+00:00",
    "planEndTime": "2024-08-29T16:00:00.000+00:00",
    "planWorkDay": 93,
    "realStartTime": "2024-08-01T00:00:00.000+00:00",
    "realEndTime": "2024-08-30T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630708518027264",
    "taskOwnerName": "刘也（刘凯豪）",
    "taskStatus": "COMPLETED",
    "sortNo": 1,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096850",
    "taskCode": "TASK-20250409000813",
    "taskName": "五看分析",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "sales_line",
    "bizLineName": "营销线",
    "bizStage": "02",
    "bizStageName": "设计",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-08-31T16:00:00.000+00:00",
    "planEndTime": "2024-09-14T16:00:00.000+00:00",
    "planWorkDay": 15,
    "realStartTime": "2024-09-01T00:00:00.000+00:00",
    "realEndTime": "2024-09-15T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630133437005824",
    "taskOwnerName": "星星（陈怡欣）",
    "taskStatus": "COMPLETED",
    "sortNo": 22,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096851",
    "taskCode": "TASK-20250409000814",
    "taskName": "确认产品市场定位（对标竞品、目标人群等）",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "sales_line",
    "bizLineName": "营销线",
    "bizStage": "02",
    "bizStageName": "设计",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-08-31T16:00:00.000+00:00",
    "planEndTime": "2024-09-14T16:00:00.000+00:00",
    "planWorkDay": 15,
    "realStartTime": "2024-09-01T00:00:00.000+00:00",
    "realEndTime": "2024-09-15T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630133437005824",
    "taskOwnerName": "星星（陈怡欣）",
    "taskStatus": "COMPLETED",
    "sortNo": 23,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096852",
    "taskCode": "TASK-20250409000815",
    "taskName": "确认产品品牌内定位（品线规划、IP资源）",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "sales_line",
    "bizLineName": "营销线",
    "bizStage": "02",
    "bizStageName": "设计",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-08-31T16:00:00.000+00:00",
    "planEndTime": "2024-09-14T16:00:00.000+00:00",
    "planWorkDay": 15,
    "realStartTime": "2024-09-15T00:00:00.000+00:00",
    "realEndTime": "2025-04-15T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630133437005824",
    "taskOwnerName": "星星（陈怡欣）",
    "taskStatus": "COMPLETED",
    "sortNo": 24,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096885",
    "taskCode": "TASK-20250409000848",
    "taskName": "商业五看",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "ready_line",
    "bizLineName": "上市准备线",
    "bizStage": "02",
    "bizStageName": "设计",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-09-01T16:00:00.000+00:00",
    "planEndTime": "2024-09-22T16:00:00.000+00:00",
    "planWorkDay": 72,
    "realStartTime": "2024-09-02T00:00:00.000+00:00",
    "realEndTime": "2024-09-23T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630743519494144",
    "taskOwnerName": "镜子（李静）",
    "taskStatus": "COMPLETED",
    "sortNo": 57,
    "comment": null,
    "color": null,
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096884",
    "taskCode": "TASK-20250409000847",
    "taskName": "制定初版4P策略/GWP方案（含中小样）",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "ready_line",
    "bizLineName": "上市准备线",
    "bizStage": "02",
    "bizStageName": "设计",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-09-01T16:00:00.000+00:00",
    "planEndTime": "2024-09-12T16:00:00.000+00:00",
    "planWorkDay": 30,
    "realStartTime": "2024-09-02T00:00:00.000+00:00",
    "realEndTime": "2024-09-13T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630743519494144",
    "taskOwnerName": "镜子（李静）",
    "taskStatus": "COMPLETED",
    "sortNo": 56,
    "comment": null,
    "color": null,
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096883",
    "taskCode": "TASK-20250409000846",
    "taskName": "渠道营销资源需求收集",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "ready_line",
    "bizLineName": "上市准备线",
    "bizStage": "02",
    "bizStageName": "设计",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-09-01T16:00:00.000+00:00",
    "planEndTime": "2024-09-05T16:00:00.000+00:00",
    "planWorkDay": 30,
    "realStartTime": "2024-09-02T00:00:00.000+00:00",
    "realEndTime": "2024-09-06T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630743519494144",
    "taskOwnerName": "镜子（李静）",
    "taskStatus": "COMPLETED",
    "sortNo": 55,
    "comment": null,
    "color": null,
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096882",
    "taskCode": "TASK-20250409000845",
    "taskName": "渠道销售资源需求收集",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "ready_line",
    "bizLineName": "上市准备线",
    "bizStage": "02",
    "bizStageName": "设计",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-09-01T16:00:00.000+00:00",
    "planEndTime": "2024-09-05T16:00:00.000+00:00",
    "planWorkDay": 30,
    "realStartTime": "2024-09-02T00:00:00.000+00:00",
    "realEndTime": "2024-09-06T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630743519494144",
    "taskOwnerName": "镜子（李静）",
    "taskStatus": "COMPLETED",
    "sortNo": 54,
    "comment": null,
    "color": null,
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096881",
    "taskCode": "TASK-20250409000844",
    "taskName": "收集渠道对产品包装（辅包）、卖点需求",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "ready_line",
    "bizLineName": "上市准备线",
    "bizStage": "02",
    "bizStageName": "设计",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-09-01T16:00:00.000+00:00",
    "planEndTime": "2024-09-05T16:00:00.000+00:00",
    "planWorkDay": 20,
    "realStartTime": "2024-09-02T00:00:00.000+00:00",
    "realEndTime": "2025-04-06T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630743519494144",
    "taskOwnerName": "镜子（李静）",
    "taskStatus": "COMPLETED",
    "sortNo": 53,
    "comment": null,
    "color": null,
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096853",
    "taskCode": "TASK-20250409000816",
    "taskName": "设计产品属性（必备属性、期望属性...）",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "sales_line",
    "bizLineName": "营销线",
    "bizStage": "02",
    "bizStageName": "设计",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-09-09T16:00:00.000+00:00",
    "planEndTime": "2024-09-19T16:00:00.000+00:00",
    "planWorkDay": 15,
    "realStartTime": "2024-09-01T00:00:00.000+00:00",
    "realEndTime": "2024-09-15T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630133437005824",
    "taskOwnerName": "星星（陈怡欣）",
    "taskStatus": "COMPLETED",
    "sortNo": 25,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096886",
    "taskCode": "TASK-20250409000849",
    "taskName": "Gate2评审结果决策",
    "description": null,
    "taskType": "GATE",
    "bizLine": "ready_line",
    "bizLineName": "上市准备线",
    "bizStage": "02",
    "bizStageName": "设计",
    "keyTask": false,
    "keyLineTask": false,
    "milestoneTask": true,
    "milestoneNode": "GATE2",
    "controlTask": true,
    "planStartTime": "2024-09-16T16:00:00.000+00:00",
    "planEndTime": "2024-09-22T16:00:00.000+00:00",
    "planWorkDay": 7,
    "realStartTime": "2024-09-17T00:00:00.000+00:00",
    "realEndTime": "2025-04-23T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630743519494144",
    "taskOwnerName": "镜子（李静）",
    "taskStatus": "COMPLETED",
    "sortNo": 58,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [
      {
        "id": "522613123413180419",
        "taskId": "522613122591096881",
        "taskCode": "TASK-20250409000844",
        "taskName": "收集渠道对产品包装（辅包）、卖点需求",
        "preRelateType": "FS"
      },
      {
        "id": "522613123417374720",
        "taskId": "522613122591096882",
        "taskCode": "TASK-20250409000845",
        "taskName": "渠道销售资源需求收集",
        "preRelateType": "FS"
      },
      {
        "id": "522613123417374721",
        "taskId": "522613122591096883",
        "taskCode": "TASK-20250409000846",
        "taskName": "渠道营销资源需求收集",
        "preRelateType": "FS"
      },
      {
        "id": "522613123417374722",
        "taskId": "522613122591096884",
        "taskCode": "TASK-20250409000847",
        "taskName": "制定初版4P策略/GWP方案（含中小样）",
        "preRelateType": "FS"
      },
      {
        "id": "522613123417374723",
        "taskId": "522613122591096885",
        "taskCode": "TASK-20250409000848",
        "taskName": "商业五看",
        "preRelateType": "FS"
      }
    ],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122899968334",
    "taskCode": "TASK-20250409001293",
    "taskName": "财务模型评估",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "product_line",
    "bizLineName": "产品开发线",
    "bizStage": "02",
    "bizStageName": "设计",
    "keyTask": false,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-09-17T16:00:00.000+00:00",
    "planEndTime": "2024-09-19T16:00:00.000+00:00",
    "planWorkDay": 3,
    "realStartTime": "2025-04-23T00:00:00.000+00:00",
    "realEndTime": "2025-04-23T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630678994321408",
    "taskOwnerName": "乐风（黄晨）",
    "taskStatus": "COMPLETED",
    "sortNo": 6,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096834",
    "taskCode": "TASK-20250409000797",
    "taskName": "整理gate 2评审材料",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "product_line",
    "bizLineName": "产品开发线",
    "bizStage": "02",
    "bizStageName": "设计",
    "keyTask": false,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-09-17T16:00:00.000+00:00",
    "planEndTime": "2024-09-19T16:00:00.000+00:00",
    "planWorkDay": 2,
    "realStartTime": "2024-09-18T00:00:00.000+00:00",
    "realEndTime": "2024-09-20T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630464401145856",
    "taskOwnerName": "桃桃（杨婕）",
    "taskStatus": "COMPLETED",
    "sortNo": 6,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [
      {
        "id": "522613123383820288",
        "taskId": "522613122591096833",
        "taskCode": "TASK-20250409000796",
        "taskName": "确定供应商短名单",
        "preRelateType": "FS"
      },
      {
        "id": "522613123383820289",
        "taskId": "522613122586902531",
        "taskCode": "TASK-20250409000794",
        "taskName": "灌装小试",
        "preRelateType": "FS"
      }
    ],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096835",
    "taskCode": "TASK-20250409000798",
    "taskName": "Gate2评审结果拟定",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "product_line",
    "bizLineName": "产品开发线",
    "bizStage": "02",
    "bizStageName": "设计",
    "keyTask": false,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-09-19T16:00:00.000+00:00",
    "planEndTime": "2024-09-21T16:00:00.000+00:00",
    "planWorkDay": 3,
    "realStartTime": "2024-09-20T00:00:00.000+00:00",
    "realEndTime": "2024-09-22T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630464401145856",
    "taskOwnerName": "桃桃（杨婕）",
    "taskStatus": "COMPLETED",
    "sortNo": 7,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [
      {
        "id": "522613123383820290",
        "taskId": "522613122591096834",
        "taskCode": "TASK-20250409000797",
        "taskName": "整理gate 2评审材料",
        "preRelateType": "FS"
      }
    ],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096854",
    "taskCode": "TASK-20250409000817",
    "taskName": "Gate2评审结果决策",
    "description": null,
    "taskType": "GATE",
    "bizLine": "sales_line",
    "bizLineName": "营销线",
    "bizStage": "02",
    "bizStageName": "设计",
    "keyTask": false,
    "keyLineTask": false,
    "milestoneTask": true,
    "milestoneNode": "GATE2",
    "controlTask": true,
    "planStartTime": "2024-09-20T16:00:00.000+00:00",
    "planEndTime": "2024-09-22T16:00:00.000+00:00",
    "planWorkDay": 7,
    "realStartTime": "2024-09-01T00:00:00.000+00:00",
    "realEndTime": "2024-09-15T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630133437005824",
    "taskOwnerName": "星星（陈怡欣）",
    "taskStatus": "COMPLETED",
    "sortNo": 26,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [
      {
        "id": "522613123400597504",
        "taskId": "522613122591096850",
        "taskCode": "TASK-20250409000813",
        "taskName": "五看分析",
        "preRelateType": "FS"
      },
      {
        "id": "522613123400597505",
        "taskId": "522613122591096851",
        "taskCode": "TASK-20250409000814",
        "taskName": "确认产品市场定位（对标竞品、目标人群等）",
        "preRelateType": "FS"
      },
      {
        "id": "522613123400597506",
        "taskId": "522613122591096852",
        "taskCode": "TASK-20250409000815",
        "taskName": "确认产品品牌内定位（品线规划、IP资源）",
        "preRelateType": "FS"
      },
      {
        "id": "522613123400597507",
        "taskId": "522613122591096853",
        "taskCode": "TASK-20250409000816",
        "taskName": "设计产品属性（必备属性、期望属性...）",
        "preRelateType": "FS"
      }
    ],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096891",
    "taskCode": "TASK-20250409000854",
    "taskName": "会员派样货量提报",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "ready_line",
    "bizLineName": "上市准备线",
    "bizStage": "03",
    "bizStageName": "放大验证",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-09-22T16:00:00.000+00:00",
    "planEndTime": "2024-09-26T16:00:00.000+00:00",
    "planWorkDay": 10,
    "realStartTime": "2024-09-23T00:00:00.000+00:00",
    "realEndTime": "2024-09-27T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630743519494144",
    "taskOwnerName": "镜子（李静）",
    "taskStatus": "COMPLETED",
    "sortNo": 63,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [
      {
        "id": "522613123421569024",
        "taskId": "522613122591096889",
        "taskCode": "TASK-20250409000852",
        "taskName": "渠道销售方案制定",
        "preRelateType": "FS"
      }
    ],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096892",
    "taskCode": "TASK-20250409000855",
    "taskName": "对客素材需求收集",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "ready_line",
    "bizLineName": "上市准备线",
    "bizStage": "03",
    "bizStageName": "放大验证",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-09-22T16:00:00.000+00:00",
    "planEndTime": "2024-09-29T16:00:00.000+00:00",
    "planWorkDay": 20,
    "realStartTime": "2024-09-23T00:00:00.000+00:00",
    "realEndTime": "2024-09-30T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630743519494144",
    "taskOwnerName": "镜子（李静）",
    "taskStatus": "COMPLETED",
    "sortNo": 64,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [
      {
        "id": "522613123421569025",
        "taskId": "522613122591096889",
        "taskCode": "TASK-20250409000852",
        "taskName": "渠道销售方案制定",
        "preRelateType": "FS"
      }
    ],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096858",
    "taskCode": "TASK-20250409000821",
    "taskName": "拆解营销商业目标",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "sales_line",
    "bizLineName": "营销线",
    "bizStage": "03",
    "bizStageName": "放大验证",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-09-22T16:00:00.000+00:00",
    "planEndTime": "2024-10-21T16:00:00.000+00:00",
    "planWorkDay": 30,
    "realStartTime": "2024-09-23T00:00:00.000+00:00",
    "realEndTime": "2024-10-22T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630133437005824",
    "taskOwnerName": "星星（陈怡欣）",
    "taskStatus": "COMPLETED",
    "sortNo": 30,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096843",
    "taskCode": "TASK-20250409000806",
    "taskName": "确定供应商方案",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "product_line",
    "bizLineName": "产品开发线",
    "bizStage": "03",
    "bizStageName": "放大验证",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-09-22T16:00:00.000+00:00",
    "planEndTime": "2024-10-18T16:00:00.000+00:00",
    "planWorkDay": 30,
    "realStartTime": "2023-09-25T00:00:00.000+00:00",
    "realEndTime": "2023-10-06T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630688100155392",
    "taskOwnerName": "剑峰（颜剑峰）",
    "taskStatus": "COMPLETED",
    "sortNo": 15,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [
      {
        "id": "522613123392208896",
        "taskId": "522613122586902528",
        "taskCode": "TASK-20250409000791",
        "taskName": "配方开发验证",
        "preRelateType": "FS"
      }
    ],
    "executors": [],
    "followers": [],
    "children": [
      {
        "id": "524742484346011649",
        "taskCode": "TASK-20250415000008",
        "taskName": "财务评估",
        "description": null,
        "taskType": "NORMAL",
        "bizLine": "product_line",
        "bizLineName": "产品开发线",
        "bizStage": "03",
        "bizStageName": "放大验证",
        "keyTask": false,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": false,
        "planStartTime": "2024-09-22T16:00:00.000+00:00",
        "planEndTime": "2024-09-22T16:00:00.000+00:00",
        "planWorkDay": 1,
        "realStartTime": "2025-04-28T00:00:00.000+00:00",
        "realEndTime": "2025-04-28T00:00:00.000+00:00",
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630678994321408",
        "taskOwnerName": "乐风（黄晨）",
        "taskStatus": "COMPLETED",
        "sortNo": 1,
        "comment": "",
        "color": "",
        "createdTime": "2025-04-15T06:44:28.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122591096843",
        "parentTaskName": "确定供应商方案"
      },
      {
        "id": "524742484346011648",
        "taskCode": "TASK-20250415000007",
        "taskName": "供应风险评估",
        "description": null,
        "taskType": "NORMAL",
        "bizLine": "product_line",
        "bizLineName": "产品开发线",
        "bizStage": "03",
        "bizStageName": "放大验证",
        "keyTask": false,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": false,
        "planStartTime": "2024-09-22T16:00:00.000+00:00",
        "planEndTime": "2024-09-26T16:00:00.000+00:00",
        "planWorkDay": 5,
        "realStartTime": "2024-10-25T00:00:00.000+00:00",
        "realEndTime": "2024-10-30T00:00:00.000+00:00",
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630571330732032",
        "taskOwnerName": "子青（李梦娟）",
        "taskStatus": "COMPLETED",
        "sortNo": 0,
        "comment": "供应风险评估内容整合进gate 3汇报 资料",
        "color": "",
        "createdTime": "2025-04-15T06:44:28.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122591096843",
        "parentTaskName": "确定供应商方案"
      },
      {
        "id": "524742484346011650",
        "taskCode": "TASK-20250415000009",
        "taskName": "更新财务模型",
        "description": null,
        "taskType": "NORMAL",
        "bizLine": "product_line",
        "bizLineName": "产品开发线",
        "bizStage": "03",
        "bizStageName": "放大验证",
        "keyTask": false,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": false,
        "planStartTime": "2024-09-22T16:00:00.000+00:00",
        "planEndTime": "2024-09-22T16:00:00.000+00:00",
        "planWorkDay": 1,
        "realStartTime": "2025-04-28T00:00:00.000+00:00",
        "realEndTime": "2025-04-28T00:00:00.000+00:00",
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630678994321408",
        "taskOwnerName": "乐风（黄晨）",
        "taskStatus": "COMPLETED",
        "sortNo": 2,
        "comment": "",
        "color": "",
        "createdTime": "2025-04-15T06:44:28.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122591096843",
        "parentTaskName": "确定供应商方案"
      },
      {
        "id": "524742484346011651",
        "taskCode": "TASK-20250415000010",
        "taskName": "确定大货成本",
        "description": null,
        "taskType": "NORMAL",
        "bizLine": "product_line",
        "bizLineName": "产品开发线",
        "bizStage": "03",
        "bizStageName": "放大验证",
        "keyTask": false,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": false,
        "planStartTime": "2024-09-22T16:00:00.000+00:00",
        "planEndTime": "2024-09-22T16:00:00.000+00:00",
        "planWorkDay": 1,
        "realStartTime": "2023-09-23T00:00:00.000+00:00",
        "realEndTime": "2023-09-23T00:00:00.000+00:00",
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630688100155392",
        "taskOwnerName": "剑峰（颜剑峰）",
        "taskStatus": "COMPLETED",
        "sortNo": 3,
        "comment": "成本确认",
        "color": "",
        "createdTime": "2025-04-15T06:44:28.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122591096843",
        "parentTaskName": "确定供应商方案"
      },
      {
        "id": "524742484346011652",
        "taskCode": "TASK-20250415000011",
        "taskName": "终版供应方案",
        "description": null,
        "taskType": "NORMAL",
        "bizLine": "product_line",
        "bizLineName": "产品开发线",
        "bizStage": "03",
        "bizStageName": "放大验证",
        "keyTask": false,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": false,
        "planStartTime": "2024-09-22T16:00:00.000+00:00",
        "planEndTime": "2024-09-26T16:00:00.000+00:00",
        "planWorkDay": 5,
        "realStartTime": "2024-09-20T00:00:00.000+00:00",
        "realEndTime": "2024-09-25T00:00:00.000+00:00",
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630571330732032",
        "taskOwnerName": "子青（李梦娟）",
        "taskStatus": "COMPLETED",
        "sortNo": 4,
        "comment": "",
        "color": "",
        "createdTime": "2025-04-15T06:44:28.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122591096843",
        "parentTaskName": "确定供应商方案"
      },
      {
        "id": "524742484346011653",
        "taskCode": "TASK-20250415000012",
        "taskName": "首批订单确认",
        "description": null,
        "taskType": "NORMAL",
        "bizLine": "product_line",
        "bizLineName": "产品开发线",
        "bizStage": "03",
        "bizStageName": "放大验证",
        "keyTask": false,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": false,
        "planStartTime": "2024-09-22T16:00:00.000+00:00",
        "planEndTime": "2024-09-26T16:00:00.000+00:00",
        "planWorkDay": 5,
        "realStartTime": "2024-09-23T00:00:00.000+00:00",
        "realEndTime": "2024-09-27T00:00:00.000+00:00",
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630464401145856",
        "taskOwnerName": "桃桃（杨婕）",
        "taskStatus": "COMPLETED",
        "sortNo": 5,
        "comment": "",
        "color": "",
        "createdTime": "2025-04-15T06:44:28.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122591096843",
        "parentTaskName": "确定供应商方案"
      }
    ],
    "childNum": 6,
    "childFinNum": 6,
    "allChildNum": 6,
    "allChildFinNum": 6,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096838",
    "taskCode": "TASK-20250409000801",
    "taskName": "配方生产验证",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "product_line",
    "bizLineName": "产品开发线",
    "bizStage": "03",
    "bizStageName": "放大验证",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-09-22T16:00:00.000+00:00",
    "planEndTime": "2024-10-14T16:00:00.000+00:00",
    "planWorkDay": 15,
    "realStartTime": "2024-09-25T00:00:00.000+00:00",
    "realEndTime": "2024-09-30T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630866412601344",
    "taskOwnerName": "元恺（钱峰）",
    "taskStatus": "COMPLETED",
    "sortNo": 10,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [],
    "executors": [],
    "followers": [],
    "children": [
      {
        "id": "525042621173727233",
        "taskCode": "TASK-20250416000002",
        "taskName": "料体稳定性测试",
        "description": "交付内容：1、稳定性测试；2、料体检测（防腐剂含量）；3、料体检测-重金属、风险物质；4、料体检测-功效成分(如防晒剂、烟酰胺）；5、料体检测-（理化-粘度、PH等，功能测试-跌落等",
        "taskType": "NORMAL",
        "bizLine": "product_line",
        "bizLineName": "产品开发线",
        "bizStage": "03",
        "bizStageName": "放大验证",
        "keyTask": false,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": false,
        "planStartTime": "2024-09-22T16:00:00.000+00:00",
        "planEndTime": "2024-10-14T16:00:00.000+00:00",
        "planWorkDay": 30,
        "realStartTime": "2025-04-22T00:00:00.000+00:00",
        "realEndTime": "2025-04-27T00:00:00.000+00:00",
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630812515794944",
        "taskOwnerName": "元素（彭绍远）",
        "taskStatus": "COMPLETED",
        "sortNo": 1,
        "comment": "",
        "color": "",
        "createdTime": "2025-04-16T02:37:06.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122591096838",
        "parentTaskName": "配方生产验证"
      },
      {
        "id": "525042621173727232",
        "taskCode": "TASK-20250416000001",
        "taskName": "配制中试",
        "description": "交付内容：1、配制工艺单(OEM)",
        "taskType": "NORMAL",
        "bizLine": "product_line",
        "bizLineName": "产品开发线",
        "bizStage": "03",
        "bizStageName": "放大验证",
        "keyTask": false,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": false,
        "planStartTime": "2024-09-22T16:00:00.000+00:00",
        "planEndTime": "2024-10-03T16:00:00.000+00:00",
        "planWorkDay": 12,
        "realStartTime": "2024-09-25T00:00:00.000+00:00",
        "realEndTime": "2024-09-30T00:00:00.000+00:00",
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630866412601344",
        "taskOwnerName": "元恺（钱峰）",
        "taskStatus": "COMPLETED",
        "sortNo": 0,
        "comment": "",
        "color": "",
        "createdTime": "2025-04-16T02:37:06.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122591096838",
        "parentTaskName": "配方生产验证"
      }
    ],
    "childNum": 2,
    "childFinNum": 2,
    "allChildNum": 2,
    "allChildFinNum": 2,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096836",
    "taskCode": "TASK-20250409000799",
    "taskName": "Gate2评审结果决策",
    "description": null,
    "taskType": "GATE",
    "bizLine": "product_line",
    "bizLineName": "产品开发线",
    "bizStage": "02",
    "bizStageName": "设计",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": true,
    "milestoneNode": "GATE2",
    "controlTask": true,
    "planStartTime": "2024-09-22T16:00:00.000+00:00",
    "planEndTime": "2024-09-22T16:00:00.000+00:00",
    "planWorkDay": 1,
    "realStartTime": "2024-09-23T00:00:00.000+00:00",
    "realEndTime": "2024-09-23T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630464401145856",
    "taskOwnerName": "桃桃（杨婕）",
    "taskStatus": "COMPLETED",
    "sortNo": 8,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [
      {
        "id": "522613123383820291",
        "taskId": "522613122591096835",
        "taskCode": "TASK-20250409000798",
        "taskName": "Gate2评审结果拟定",
        "preRelateType": "FS"
      }
    ],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096893",
    "taskCode": "TASK-20250409000856",
    "taskName": "渠道落地资源（IP）提报",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "ready_line",
    "bizLineName": "上市准备线",
    "bizStage": "03",
    "bizStageName": "放大验证",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-09-22T16:00:00.000+00:00",
    "planEndTime": "2024-10-11T16:00:00.000+00:00",
    "planWorkDay": 20,
    "realStartTime": "2024-09-23T00:00:00.000+00:00",
    "realEndTime": "2024-10-12T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630743519494144",
    "taskOwnerName": "镜子（李静）",
    "taskStatus": "COMPLETED",
    "sortNo": 65,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [
      {
        "id": "522613123421569026",
        "taskId": "522613122591096889",
        "taskCode": "TASK-20250409000852",
        "taskName": "渠道销售方案制定",
        "preRelateType": "FS"
      }
    ],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096859",
    "taskCode": "TASK-20250409000822",
    "taskName": "拆解营销预算",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "sales_line",
    "bizLineName": "营销线",
    "bizStage": "03",
    "bizStageName": "放大验证",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-09-22T16:00:00.000+00:00",
    "planEndTime": "2024-10-21T16:00:00.000+00:00",
    "planWorkDay": 30,
    "realStartTime": "2024-09-23T00:00:00.000+00:00",
    "realEndTime": "2024-10-23T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630133437005824",
    "taskOwnerName": "星星（陈怡欣）",
    "taskStatus": "COMPLETED",
    "sortNo": 31,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096888",
    "taskCode": "TASK-20250409000851",
    "taskName": "更新4P策略/GWP方案",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "ready_line",
    "bizLineName": "上市准备线",
    "bizStage": "03",
    "bizStageName": "放大验证",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-09-22T16:00:00.000+00:00",
    "planEndTime": "2024-09-29T16:00:00.000+00:00",
    "planWorkDay": 40,
    "realStartTime": "2024-09-23T00:00:00.000+00:00",
    "realEndTime": "2024-09-30T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630743519494144",
    "taskOwnerName": "镜子（李静）",
    "taskStatus": "COMPLETED",
    "sortNo": 60,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [
      {
        "id": "522613123417374724",
        "taskId": "522613122591096887",
        "taskCode": "TASK-20250409000850",
        "taskName": "制定用户人群策略",
        "preRelateType": "FS"
      }
    ],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096860",
    "taskCode": "TASK-20250409000823",
    "taskName": "制定营销策略",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "sales_line",
    "bizLineName": "营销线",
    "bizStage": "03",
    "bizStageName": "放大验证",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-09-22T16:00:00.000+00:00",
    "planEndTime": "2024-10-21T16:00:00.000+00:00",
    "planWorkDay": 30,
    "realStartTime": "2024-09-23T00:00:00.000+00:00",
    "realEndTime": "2024-10-22T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630133437005824",
    "taskOwnerName": "星星（陈怡欣）",
    "taskStatus": "COMPLETED",
    "sortNo": 32,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096861",
    "taskCode": "TASK-20250409000824",
    "taskName": "梳理验证营销资源",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "sales_line",
    "bizLineName": "营销线",
    "bizStage": "03",
    "bizStageName": "放大验证",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-09-22T16:00:00.000+00:00",
    "planEndTime": "2024-10-21T16:00:00.000+00:00",
    "planWorkDay": 30,
    "realStartTime": "2024-09-23T00:00:00.000+00:00",
    "realEndTime": "2024-10-22T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630133437005824",
    "taskOwnerName": "星星（陈怡欣）",
    "taskStatus": "COMPLETED",
    "sortNo": 33,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096862",
    "taskCode": "TASK-20250409000825",
    "taskName": "制定整合营销方案&预算",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "sales_line",
    "bizLineName": "营销线",
    "bizStage": "03",
    "bizStageName": "放大验证",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-09-22T16:00:00.000+00:00",
    "planEndTime": "2024-10-21T16:00:00.000+00:00",
    "planWorkDay": 30,
    "realStartTime": "2024-09-23T00:00:00.000+00:00",
    "realEndTime": "2024-10-22T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630133437005824",
    "taskOwnerName": "星星（陈怡欣）",
    "taskStatus": "COMPLETED",
    "sortNo": 34,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096857",
    "taskCode": "TASK-20250409000820",
    "taskName": "筹备产品种子素材包",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "sales_line",
    "bizLineName": "营销线",
    "bizStage": "03",
    "bizStageName": "放大验证",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-09-22T16:00:00.000+00:00",
    "planEndTime": "2024-09-28T16:00:00.000+00:00",
    "planWorkDay": 7,
    "realStartTime": "2024-09-23T00:00:00.000+00:00",
    "realEndTime": "2024-10-23T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630133437005824",
    "taskOwnerName": "星星（陈怡欣）",
    "taskStatus": "COMPLETED",
    "sortNo": 29,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096856",
    "taskCode": "TASK-20250409000819",
    "taskName": "初版产品种子内容策划",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "sales_line",
    "bizLineName": "营销线",
    "bizStage": "03",
    "bizStageName": "放大验证",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-09-22T16:00:00.000+00:00",
    "planEndTime": "2024-10-21T16:00:00.000+00:00",
    "planWorkDay": 30,
    "realStartTime": "2024-09-23T00:00:00.000+00:00",
    "realEndTime": "2024-10-22T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630133437005824",
    "taskOwnerName": "星星（陈怡欣）",
    "taskStatus": "COMPLETED",
    "sortNo": 28,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096855",
    "taskCode": "TASK-20250409000818",
    "taskName": "产品卖点深度挖掘",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "sales_line",
    "bizLineName": "营销线",
    "bizStage": "03",
    "bizStageName": "放大验证",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-09-22T16:00:00.000+00:00",
    "planEndTime": "2024-10-21T16:00:00.000+00:00",
    "planWorkDay": 30,
    "realStartTime": "2024-09-23T00:00:00.000+00:00",
    "realEndTime": "2024-10-22T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630133437005824",
    "taskOwnerName": "星星（陈怡欣）",
    "taskStatus": "COMPLETED",
    "sortNo": 27,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096887",
    "taskCode": "TASK-20250409000850",
    "taskName": "制定用户人群策略",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "ready_line",
    "bizLineName": "上市准备线",
    "bizStage": "03",
    "bizStageName": "放大验证",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-09-22T16:00:00.000+00:00",
    "planEndTime": "2024-09-26T16:00:00.000+00:00",
    "planWorkDay": 10,
    "realStartTime": "2024-09-23T00:00:00.000+00:00",
    "realEndTime": "2024-09-27T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630743519494144",
    "taskOwnerName": "镜子（李静）",
    "taskStatus": "COMPLETED",
    "sortNo": 59,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591097005",
    "taskCode": "TASK-20250409001277",
    "taskName": "输出中试生产条件确认单",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "product_line",
    "bizLineName": "产品开发线",
    "bizStage": "03",
    "bizStageName": "放大验证",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": false,
    "planStartTime": "2024-09-23T16:00:00.000+00:00",
    "planEndTime": "2024-09-23T16:00:00.000+00:00",
    "planWorkDay": 1,
    "realStartTime": "2025-04-22T00:00:00.000+00:00",
    "realEndTime": "2025-04-27T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630812515794944",
    "taskOwnerName": "元素（彭绍远）",
    "taskStatus": "COMPLETED",
    "sortNo": 15,
    "comment": "",
    "color": "green",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [
      {
        "id": "524776353954791431",
        "taskId": "522613122591096836",
        "taskCode": "TASK-20250409000799",
        "taskName": "Gate2评审结果决策",
        "preRelateType": "FS"
      }
    ],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096837",
    "taskCode": "TASK-20250409000800",
    "taskName": "中试下单",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "product_line",
    "bizLineName": "产品开发线",
    "bizStage": "03",
    "bizStageName": "放大验证",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": true,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-09-24T16:00:00.000+00:00",
    "planEndTime": "2024-09-28T16:00:00.000+00:00",
    "planWorkDay": 7,
    "realStartTime": "2024-09-25T00:00:00.000+00:00",
    "realEndTime": "2024-09-29T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630464401145856",
    "taskOwnerName": "桃桃（杨婕）",
    "taskStatus": "COMPLETED",
    "sortNo": 9,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [
      {
        "id": "522613123383820292",
        "taskId": "522613122591097005",
        "taskCode": "TASK-20250409001277",
        "taskName": "输出中试生产条件确认单",
        "preRelateType": "FS"
      }
    ],
    "executors": [],
    "followers": [],
    "children": [
      {
        "id": "524695485852680192",
        "taskCode": "TASK-20250415000002",
        "taskName": "确认中试订单需求",
        "description": null,
        "taskType": "NORMAL",
        "bizLine": "product_line",
        "bizLineName": "产品开发线",
        "bizStage": "03",
        "bizStageName": "放大验证",
        "keyTask": false,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": false,
        "planStartTime": "2024-09-22T16:00:00.000+00:00",
        "planEndTime": "2024-09-22T16:00:00.000+00:00",
        "planWorkDay": 1,
        "realStartTime": "2024-09-23T00:00:00.000+00:00",
        "realEndTime": "2024-09-23T00:00:00.000+00:00",
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630464401145856",
        "taskOwnerName": "桃桃（杨婕）",
        "taskStatus": "COMPLETED",
        "sortNo": 0,
        "comment": "https://smmqalicrx.feishu.cn/sheets/EQM5sJgGHhEJVNts2KgcEtlanOd?from=from_copylink",
        "color": "",
        "createdTime": "2025-04-15T03:37:42.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122591096837",
        "parentTaskName": "中试下单"
      },
      {
        "id": "524695485856874496",
        "taskCode": "TASK-20250415000004",
        "taskName": "检查包材中试验证计划",
        "description": null,
        "taskType": "NORMAL",
        "bizLine": "product_line",
        "bizLineName": "产品开发线",
        "bizStage": "03",
        "bizStageName": "放大验证",
        "keyTask": false,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": false,
        "planStartTime": "2024-09-22T16:00:00.000+00:00",
        "planEndTime": "2024-09-23T16:00:00.000+00:00",
        "planWorkDay": 2,
        "realStartTime": "2025-04-21T00:00:00.000+00:00",
        "realEndTime": "2025-04-25T00:00:00.000+00:00",
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630812515794944",
        "taskOwnerName": "元素（彭绍远）",
        "taskStatus": "COMPLETED",
        "sortNo": 2,
        "comment": "中试验证计划物异常，按照中试验证计划进行",
        "color": "",
        "createdTime": "2025-04-15T03:37:42.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122591096837",
        "parentTaskName": "中试下单"
      },
      {
        "id": "524695485856874497",
        "taskCode": "TASK-20250415000005",
        "taskName": "中试采购计划",
        "description": null,
        "taskType": "NORMAL",
        "bizLine": "product_line",
        "bizLineName": "产品开发线",
        "bizStage": "03",
        "bizStageName": "放大验证",
        "keyTask": false,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": false,
        "planStartTime": "2024-09-22T16:00:00.000+00:00",
        "planEndTime": "2024-09-24T16:00:00.000+00:00",
        "planWorkDay": 3,
        "realStartTime": "2024-08-05T00:00:00.000+00:00",
        "realEndTime": "2024-08-05T00:00:00.000+00:00",
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630571330732032",
        "taskOwnerName": "子青（李梦娟）",
        "taskStatus": "COMPLETED",
        "sortNo": 3,
        "comment": "",
        "color": "",
        "createdTime": "2025-04-15T03:37:42.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122591096837",
        "parentTaskName": "中试下单"
      },
      {
        "id": "524695485856874498",
        "taskCode": "TASK-20250415000006",
        "taskName": "中试订单",
        "description": null,
        "taskType": "NORMAL",
        "bizLine": "product_line",
        "bizLineName": "产品开发线",
        "bizStage": "03",
        "bizStageName": "放大验证",
        "keyTask": false,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": false,
        "planStartTime": "2024-09-22T16:00:00.000+00:00",
        "planEndTime": "2024-09-26T16:00:00.000+00:00",
        "planWorkDay": 5,
        "realStartTime": "2024-09-23T00:00:00.000+00:00",
        "realEndTime": "2024-09-27T00:00:00.000+00:00",
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630644240318464",
        "taskOwnerName": "紫苏（郑贵妃）",
        "taskStatus": "COMPLETED",
        "sortNo": 4,
        "comment": "",
        "color": "",
        "createdTime": "2025-04-15T03:37:42.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122591096837",
        "parentTaskName": "中试下单"
      }
    ],
    "childNum": 4,
    "childFinNum": 4,
    "allChildNum": 4,
    "allChildFinNum": 4,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096839",
    "taskCode": "TASK-20250409000802",
    "taskName": "中试包材生产验证",
    "description": "交付内容：1、包材中试验证计划；2、包材开发中试测试：外观、尺寸、规格；3、包材结构功能测试；4、包材工艺性能测试；5、适配测试；6、表面涂抹测试；7、中试样签样提供；8、包材中试标准样；9、包材规格书制定",
    "taskType": "NORMAL",
    "bizLine": "product_line",
    "bizLineName": "产品开发线",
    "bizStage": "03",
    "bizStageName": "放大验证",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-09-30T16:00:00.000+00:00",
    "planEndTime": "2024-10-14T16:00:00.000+00:00",
    "planWorkDay": 15,
    "realStartTime": "2024-10-01T00:00:00.000+00:00",
    "realEndTime": "2024-10-15T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630840726683648",
    "taskOwnerName": "小丸子（丛爽）",
    "taskStatus": "COMPLETED",
    "sortNo": 11,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [
      {
        "id": "522613123388014592",
        "taskId": "522613122591096837",
        "taskCode": "TASK-20250409000800",
        "taskName": "中试下单",
        "preRelateType": "FS"
      }
    ],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096889",
    "taskCode": "TASK-20250409000852",
    "taskName": "渠道销售方案制定",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "ready_line",
    "bizLineName": "上市准备线",
    "bizStage": "03",
    "bizStageName": "放大验证",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-10-07T16:00:00.000+00:00",
    "planEndTime": "2024-10-17T16:00:00.000+00:00",
    "planWorkDay": 30,
    "realStartTime": "2024-10-08T00:00:00.000+00:00",
    "realEndTime": "2024-10-18T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630743519494144",
    "taskOwnerName": "镜子（李静）",
    "taskStatus": "COMPLETED",
    "sortNo": 61,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096894",
    "taskCode": "TASK-20250409000857",
    "taskName": "渠道提报前3月报量",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "ready_line",
    "bizLineName": "上市准备线",
    "bizStage": "03",
    "bizStageName": "放大验证",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-10-13T16:00:00.000+00:00",
    "planEndTime": "2024-10-17T16:00:00.000+00:00",
    "planWorkDay": 40,
    "realStartTime": "2024-10-14T00:00:00.000+00:00",
    "realEndTime": "2024-10-18T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630743519494144",
    "taskOwnerName": "镜子（李静）",
    "taskStatus": "COMPLETED",
    "sortNo": 66,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096840",
    "taskCode": "TASK-20250409000803",
    "taskName": "灌装中试",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "product_line",
    "bizLineName": "产品开发线",
    "bizStage": "03",
    "bizStageName": "放大验证",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-10-15T16:00:00.000+00:00",
    "planEndTime": "2024-10-30T16:00:00.000+00:00",
    "planWorkDay": 15,
    "realStartTime": "2024-10-16T00:00:00.000+00:00",
    "realEndTime": "2024-10-31T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630464401145856",
    "taskOwnerName": "桃桃（杨婕）",
    "taskStatus": "COMPLETED",
    "sortNo": 12,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [
      {
        "id": "522613123388014593",
        "taskId": "522613122591096839",
        "taskCode": "TASK-20250409000802",
        "taskName": "中试包材生产验证",
        "preRelateType": "FS"
      },
      {
        "id": "522613123388014594",
        "taskId": "522613122591096838",
        "taskCode": "TASK-20250409000801",
        "taskName": "配方生产验证",
        "preRelateType": "FS"
      }
    ],
    "executors": [],
    "followers": [],
    "children": [
      {
        "id": "525514392243011585",
        "taskCode": "TASK-20250417000025",
        "taskName": "灌包中试",
        "description": "交付内容：1、初版灌包作业指导书（仅OEM)；2、灌包中试验证计划；3、灌包生产（现场）；4、净含量、功能测试、跌落测试、外观等；5、丢包测试；6、灌包中试验证报告",
        "taskType": "NORMAL",
        "bizLine": "product_line",
        "bizLineName": "产品开发线",
        "bizStage": "03",
        "bizStageName": "放大验证",
        "keyTask": false,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": false,
        "planStartTime": "2024-10-15T16:00:00.000+00:00",
        "planEndTime": "2024-10-26T16:00:00.000+00:00",
        "planWorkDay": 12,
        "realStartTime": "2024-10-16T00:00:00.000+00:00",
        "realEndTime": "2024-10-25T00:00:00.000+00:00",
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630866412601344",
        "taskOwnerName": "元恺（钱峰）",
        "taskStatus": "COMPLETED",
        "sortNo": 1,
        "comment": "",
        "color": "",
        "createdTime": "2025-04-17T09:51:45.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [],
        "executors": [
          {
            "id": "525514392331091968",
            "memberId": "515630812515794944",
            "memberName": "元素（彭绍远）",
            "memberRole": "EXECUTOR",
            "mainRole": true
          },
          {
            "id": "525514392331091969",
            "memberId": "515630209471348736",
            "memberName": "文俊（励文俊）",
            "memberRole": "EXECUTOR",
            "mainRole": true
          }
        ],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122591096840",
        "parentTaskName": "灌装中试"
      },
      {
        "id": "525514392243011584",
        "taskCode": "TASK-20250417000024",
        "taskName": "全新品，中试灌包后做实际快递运输测试",
        "description": "交付内容：1、模拟运输测试",
        "taskType": "NORMAL",
        "bizLine": "product_line",
        "bizLineName": "产品开发线",
        "bizStage": "03",
        "bizStageName": "放大验证",
        "keyTask": false,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": false,
        "planStartTime": "2024-10-15T16:00:00.000+00:00",
        "planEndTime": "2024-10-15T16:00:00.000+00:00",
        "planWorkDay": 1,
        "realStartTime": "2025-04-22T00:00:00.000+00:00",
        "realEndTime": "2025-04-27T00:00:00.000+00:00",
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630812515794944",
        "taskOwnerName": "元素（彭绍远）",
        "taskStatus": "COMPLETED",
        "sortNo": 0,
        "comment": "模拟运输测试OK，详见中试验证报告",
        "color": "",
        "createdTime": "2025-04-17T09:51:45.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122591096840",
        "parentTaskName": "灌装中试"
      },
      {
        "id": "525514392243011588",
        "taskCode": "TASK-20250417000028",
        "taskName": "更新包材规格书",
        "description": "交付内容：1、包材规格书",
        "taskType": "NORMAL",
        "bizLine": "product_line",
        "bizLineName": "产品开发线",
        "bizStage": "03",
        "bizStageName": "放大验证",
        "keyTask": false,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": false,
        "planStartTime": "2024-10-15T16:00:00.000+00:00",
        "planEndTime": "2024-10-26T16:00:00.000+00:00",
        "planWorkDay": 10,
        "realStartTime": "2024-10-16T00:00:00.000+00:00",
        "realEndTime": "2024-10-24T00:00:00.000+00:00",
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630840726683648",
        "taskOwnerName": "小丸子（丛爽）",
        "taskStatus": "COMPLETED",
        "sortNo": 3,
        "comment": "",
        "color": "",
        "createdTime": "2025-04-17T09:51:45.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122591096840",
        "parentTaskName": "灌装中试"
      },
      {
        "id": "525514392243011589",
        "taskCode": "TASK-20250417000029",
        "taskName": "制定配制和灌包SOP",
        "description": "交付内容：1、灌包作业指导书(仅OEM)",
        "taskType": "NORMAL",
        "bizLine": "product_line",
        "bizLineName": "产品开发线",
        "bizStage": "03",
        "bizStageName": "放大验证",
        "keyTask": false,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": false,
        "planStartTime": "2024-10-26T16:00:00.000+00:00",
        "planEndTime": "2024-10-30T16:00:00.000+00:00",
        "planWorkDay": 5,
        "realStartTime": "2024-10-28T00:00:00.000+00:00",
        "realEndTime": "2024-10-31T00:00:00.000+00:00",
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630866412601344",
        "taskOwnerName": "元恺（钱峰）",
        "taskStatus": "COMPLETED",
        "sortNo": 4,
        "comment": "",
        "color": "",
        "createdTime": "2025-04-17T09:51:45.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122591096840",
        "parentTaskName": "灌装中试"
      },
      {
        "id": "525514392243011586",
        "taskCode": "TASK-20250417000026",
        "taskName": "中试评审",
        "description": "交付内容：1、中试评审会议纪要",
        "taskType": "TR",
        "bizLine": "product_line",
        "bizLineName": "产品开发线",
        "bizStage": "03",
        "bizStageName": "放大验证",
        "keyTask": false,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": false,
        "planStartTime": "2024-10-27T16:00:00.000+00:00",
        "planEndTime": "2024-10-30T16:00:00.000+00:00",
        "planWorkDay": 2,
        "realStartTime": "2025-04-22T00:00:00.000+00:00",
        "realEndTime": "2025-04-27T00:00:00.000+00:00",
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630812515794944",
        "taskOwnerName": "元素（彭绍远）",
        "taskStatus": "COMPLETED",
        "sortNo": 2,
        "comment": "项目技术组中试评审会议公司中试验证成功，大货风险可控，可推进大货进程。",
        "color": "green",
        "createdTime": "2025-04-17T09:51:45.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [],
        "executors": [],
        "followers": [],
        "children": [
          {
            "id": "525514392243011587",
            "taskCode": "TASK-20250417000027",
            "taskName": "中试风险决策",
            "description": null,
            "taskType": "NORMAL",
            "bizLine": "product_line",
            "bizLineName": "产品开发线",
            "bizStage": "03",
            "bizStageName": "放大验证",
            "keyTask": true,
            "keyLineTask": false,
            "milestoneTask": true,
            "milestoneNode": null,
            "controlTask": false,
            "planStartTime": "2024-10-28T16:00:00.000+00:00",
            "planEndTime": "2024-10-29T16:00:00.000+00:00",
            "planWorkDay": 2,
            "realStartTime": "2025-04-22T00:00:00.000+00:00",
            "realEndTime": "2025-04-27T00:00:00.000+00:00",
            "realWorkDay": null,
            "taskProgress": null,
            "taskOwnerId": "515630812515794944",
            "taskOwnerName": "元素（彭绍远）",
            "taskStatus": "COMPLETED",
            "sortNo": 0,
            "comment": "",
            "color": "",
            "createdTime": "2025-04-17T09:51:45.000+00:00",
            "projectId": "519255487028396032",
            "documentSecret": "L0",
            "oneProductOneDoc": false,
            "interfaceWithLaboratory": false,
            "spuList": [],
            "lockTasks": [],
            "preTasks": [],
            "executors": [
              {
                "id": "525514392331091972",
                "memberId": "515630840726683648",
                "memberName": "小丸子（丛爽）",
                "memberRole": "EXECUTOR",
                "mainRole": true
              },
              {
                "id": "525514392331091973",
                "memberId": "515630866412601344",
                "memberName": "元恺（钱峰）",
                "memberRole": "EXECUTOR",
                "mainRole": true
              }
            ],
            "followers": [],
            "children": [],
            "childNum": 0,
            "childFinNum": 0,
            "allChildNum": 0,
            "allChildFinNum": 0,
            "forms": null,
            "docs": null,
            "parentId": "525514392243011586",
            "parentTaskName": "中试评审"
          }
        ],
        "childNum": 1,
        "childFinNum": 1,
        "allChildNum": 1,
        "allChildFinNum": 1,
        "forms": null,
        "docs": null,
        "parentId": "522613122591096840",
        "parentTaskName": "灌装中试"
      }
    ],
    "childNum": 5,
    "childFinNum": 5,
    "allChildNum": 6,
    "allChildFinNum": 6,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096890",
    "taskCode": "TASK-20250409000853",
    "taskName": "全域4P策略终审",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "ready_line",
    "bizLineName": "上市准备线",
    "bizStage": "03",
    "bizStageName": "放大验证",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-10-17T16:00:00.000+00:00",
    "planEndTime": "2024-10-21T16:00:00.000+00:00",
    "planWorkDay": 10,
    "realStartTime": "2024-10-18T00:00:00.000+00:00",
    "realEndTime": "2024-10-22T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630743519494144",
    "taskOwnerName": "镜子（李静）",
    "taskStatus": "COMPLETED",
    "sortNo": 62,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [
      {
        "id": "522613123417374725",
        "taskId": "522613122591096889",
        "taskCode": "TASK-20250409000852",
        "taskName": "渠道销售方案制定",
        "preRelateType": "FS"
      }
    ],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096895",
    "taskCode": "TASK-20250409000858",
    "taskName": "项目销售目标确认",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "ready_line",
    "bizLineName": "上市准备线",
    "bizStage": "03",
    "bizStageName": "放大验证",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-10-17T16:00:00.000+00:00",
    "planEndTime": "2024-10-22T16:00:00.000+00:00",
    "planWorkDay": 40,
    "realStartTime": "2024-10-18T00:00:00.000+00:00",
    "realEndTime": "2024-10-23T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630743519494144",
    "taskOwnerName": "镜子（李静）",
    "taskStatus": "COMPLETED",
    "sortNo": 67,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096863",
    "taskCode": "TASK-20250409000826",
    "taskName": "MR2",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "sales_line",
    "bizLineName": "营销线",
    "bizStage": "03",
    "bizStageName": "放大验证",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-10-22T16:00:00.000+00:00",
    "planEndTime": "2024-10-22T16:00:00.000+00:00",
    "planWorkDay": 1,
    "realStartTime": "2024-09-23T00:00:00.000+00:00",
    "realEndTime": "2024-10-22T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630133437005824",
    "taskOwnerName": "星星（陈怡欣）",
    "taskStatus": "COMPLETED",
    "sortNo": 35,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096864",
    "taskCode": "TASK-20250409000827",
    "taskName": "筹备市场推广&投放方案",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "sales_line",
    "bizLineName": "营销线",
    "bizStage": "03",
    "bizStageName": "放大验证",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-10-22T16:00:00.000+00:00",
    "planEndTime": "2024-10-28T16:00:00.000+00:00",
    "planWorkDay": 7,
    "realStartTime": "2024-10-23T00:00:00.000+00:00",
    "realEndTime": "2024-10-29T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630133437005824",
    "taskOwnerName": "星星（陈怡欣）",
    "taskStatus": "COMPLETED",
    "sortNo": 36,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096865",
    "taskCode": "TASK-20250409000828",
    "taskName": "筹备品牌营销&娱乐营销方案",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "sales_line",
    "bizLineName": "营销线",
    "bizStage": "03",
    "bizStageName": "放大验证",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-10-22T16:00:00.000+00:00",
    "planEndTime": "2024-10-28T16:00:00.000+00:00",
    "planWorkDay": 7,
    "realStartTime": "2024-10-23T00:00:00.000+00:00",
    "realEndTime": "2024-10-29T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630133437005824",
    "taskOwnerName": "星星（陈怡欣）",
    "taskStatus": "COMPLETED",
    "sortNo": 37,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096866",
    "taskCode": "TASK-20250409000829",
    "taskName": "筹备渠道营销&直播内容方案",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "sales_line",
    "bizLineName": "营销线",
    "bizStage": "03",
    "bizStageName": "放大验证",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-10-22T16:00:00.000+00:00",
    "planEndTime": "2024-10-28T16:00:00.000+00:00",
    "planWorkDay": 7,
    "realStartTime": "2024-09-23T00:00:00.000+00:00",
    "realEndTime": "2024-10-23T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630133437005824",
    "taskOwnerName": "星星（陈怡欣）",
    "taskStatus": "COMPLETED",
    "sortNo": 38,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096896",
    "taskCode": "TASK-20250409000859",
    "taskName": "项目明确阶段",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "ready_line",
    "bizLineName": "上市准备线",
    "bizStage": "03",
    "bizStageName": "放大验证",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-10-23T16:00:00.000+00:00",
    "planEndTime": "2024-11-21T16:00:00.000+00:00",
    "planWorkDay": 30,
    "realStartTime": "2024-10-24T00:00:00.000+00:00",
    "realEndTime": "2024-11-22T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630743519494144",
    "taskOwnerName": "镜子（李静）",
    "taskStatus": "COMPLETED",
    "sortNo": 68,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [],
    "executors": [],
    "followers": [],
    "children": [
      {
        "id": "522613122591096899",
        "taskCode": "TASK-20250409000862",
        "taskName": "商业模式确认",
        "description": null,
        "taskType": "NORMAL",
        "bizLine": "ready_line",
        "bizLineName": "上市准备线",
        "bizStage": "03",
        "bizStageName": "放大验证",
        "keyTask": true,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": true,
        "planStartTime": "2024-10-23T16:00:00.000+00:00",
        "planEndTime": "2024-11-21T16:00:00.000+00:00",
        "planWorkDay": 30,
        "realStartTime": "2024-10-24T00:00:00.000+00:00",
        "realEndTime": "2024-11-22T00:00:00.000+00:00",
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630743519494144",
        "taskOwnerName": "镜子（李静）",
        "taskStatus": "COMPLETED",
        "sortNo": 3,
        "comment": "",
        "color": "",
        "createdTime": "2025-04-09T09:43:08.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122591096896",
        "parentTaskName": "项目明确阶段"
      },
      {
        "id": "522613122591096898",
        "taskCode": "TASK-20250409000861",
        "taskName": "上市3个月报量确认",
        "description": null,
        "taskType": "NORMAL",
        "bizLine": "ready_line",
        "bizLineName": "上市准备线",
        "bizStage": "03",
        "bizStageName": "放大验证",
        "keyTask": false,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": true,
        "planStartTime": "2024-10-23T16:00:00.000+00:00",
        "planEndTime": "2024-11-06T16:00:00.000+00:00",
        "planWorkDay": 15,
        "realStartTime": "2024-10-24T00:00:00.000+00:00",
        "realEndTime": "2024-11-07T00:00:00.000+00:00",
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630743519494144",
        "taskOwnerName": "镜子（李静）",
        "taskStatus": "COMPLETED",
        "sortNo": 2,
        "comment": "",
        "color": "",
        "createdTime": "2025-04-09T09:43:08.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [
          {
            "id": "522613123421569028",
            "taskId": "522613122591096890",
            "taskCode": "TASK-20250409000853",
            "taskName": "全域4P策略终审",
            "preRelateType": "FS"
          }
        ],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122591096896",
        "parentTaskName": "项目明确阶段"
      },
      {
        "id": "522613122591096897",
        "taskCode": "TASK-20250409000860",
        "taskName": "新品上市规划",
        "description": null,
        "taskType": "NORMAL",
        "bizLine": "ready_line",
        "bizLineName": "上市准备线",
        "bizStage": "03",
        "bizStageName": "放大验证",
        "keyTask": false,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": true,
        "planStartTime": "2024-10-23T16:00:00.000+00:00",
        "planEndTime": "2024-11-21T16:00:00.000+00:00",
        "planWorkDay": 30,
        "realStartTime": "2024-10-24T00:00:00.000+00:00",
        "realEndTime": "2024-11-22T00:00:00.000+00:00",
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630743519494144",
        "taskOwnerName": "镜子（李静）",
        "taskStatus": "COMPLETED",
        "sortNo": 1,
        "comment": "",
        "color": "",
        "createdTime": "2025-04-09T09:43:08.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [
          {
            "id": "522613123421569027",
            "taskId": "522613122591096889",
            "taskCode": "TASK-20250409000852",
            "taskName": "渠道销售方案制定",
            "preRelateType": "FS"
          }
        ],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122591096896",
        "parentTaskName": "项目明确阶段"
      }
    ],
    "childNum": 3,
    "childFinNum": 3,
    "allChildNum": 3,
    "allChildFinNum": 3,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096868",
    "taskCode": "TASK-20250409000831",
    "taskName": "GATE3评审结果决策",
    "description": null,
    "taskType": "GATE",
    "bizLine": "sales_line",
    "bizLineName": "营销线",
    "bizStage": "03",
    "bizStageName": "放大验证",
    "keyTask": false,
    "keyLineTask": false,
    "milestoneTask": true,
    "milestoneNode": "GATE3",
    "controlTask": true,
    "planStartTime": "2024-10-26T16:00:00.000+00:00",
    "planEndTime": "2024-11-03T16:00:00.000+00:00",
    "planWorkDay": 7,
    "realStartTime": "2024-10-23T00:00:00.000+00:00",
    "realEndTime": "2024-11-07T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630133437005824",
    "taskOwnerName": "星星（陈怡欣）",
    "taskStatus": "RUNNING",
    "sortNo": 40,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [
      {
        "id": "522613123404791808",
        "taskId": "522613122591096867",
        "taskCode": "TASK-20250409000830",
        "taskName": "MR3",
        "preRelateType": "FS"
      },
      {
        "id": "522613123404791809",
        "taskId": "522613122591096855",
        "taskCode": "TASK-20250409000818",
        "taskName": "产品卖点深度挖掘",
        "preRelateType": "FS"
      },
      {
        "id": "522613123404791810",
        "taskId": "522613122591096856",
        "taskCode": "TASK-20250409000819",
        "taskName": "初版产品种子内容策划",
        "preRelateType": "FS"
      },
      {
        "id": "522613123404791811",
        "taskId": "522613122591096857",
        "taskCode": "TASK-20250409000820",
        "taskName": "筹备产品种子素材包",
        "preRelateType": "FS"
      },
      {
        "id": "522613123408986112",
        "taskId": "522613122591096859",
        "taskCode": "TASK-20250409000822",
        "taskName": "拆解营销预算",
        "preRelateType": "FS"
      },
      {
        "id": "522613123408986113",
        "taskId": "522613122591096866",
        "taskCode": "TASK-20250409000829",
        "taskName": "筹备渠道营销&直播内容方案",
        "preRelateType": "FS"
      },
      {
        "id": "522613123408986114",
        "taskId": "522613122591096865",
        "taskCode": "TASK-20250409000828",
        "taskName": "筹备品牌营销&娱乐营销方案",
        "preRelateType": "FS"
      },
      {
        "id": "522613123408986115",
        "taskId": "522613122591096864",
        "taskCode": "TASK-20250409000827",
        "taskName": "筹备市场推广&投放方案",
        "preRelateType": "FS"
      },
      {
        "id": "522613123408986116",
        "taskId": "522613122591096863",
        "taskCode": "TASK-20250409000826",
        "taskName": "MR2",
        "preRelateType": "FS"
      },
      {
        "id": "522613123408986117",
        "taskId": "522613122591096862",
        "taskCode": "TASK-20250409000825",
        "taskName": "制定整合营销方案&预算",
        "preRelateType": "FS"
      },
      {
        "id": "522613123413180416",
        "taskId": "522613122591096861",
        "taskCode": "TASK-20250409000824",
        "taskName": "梳理验证营销资源",
        "preRelateType": "FS"
      },
      {
        "id": "522613123413180417",
        "taskId": "522613122591096860",
        "taskCode": "TASK-20250409000823",
        "taskName": "制定营销策略",
        "preRelateType": "FS"
      },
      {
        "id": "522613123413180418",
        "taskId": "522613122591096858",
        "taskCode": "TASK-20250409000821",
        "taskName": "拆解营销商业目标",
        "preRelateType": "FS"
      }
    ],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096867",
    "taskCode": "TASK-20250409000830",
    "taskName": "MR3",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "sales_line",
    "bizLineName": "营销线",
    "bizStage": "03",
    "bizStageName": "放大验证",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-10-30T16:00:00.000+00:00",
    "planEndTime": "2024-10-30T16:00:00.000+00:00",
    "planWorkDay": 1,
    "realStartTime": "2024-10-31T00:00:00.000+00:00",
    "realEndTime": "2024-11-01T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630133437005824",
    "taskOwnerName": "星星（陈怡欣）",
    "taskStatus": "COMPLETED",
    "sortNo": 39,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096844",
    "taskCode": "TASK-20250409000807",
    "taskName": "汇总GATE3材料",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "product_line",
    "bizLineName": "产品开发线",
    "bizStage": "03",
    "bizStageName": "放大验证",
    "keyTask": false,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-10-30T16:00:00.000+00:00",
    "planEndTime": "2024-10-31T16:00:00.000+00:00",
    "planWorkDay": 2,
    "realStartTime": "2024-10-31T00:00:00.000+00:00",
    "realEndTime": "2024-11-01T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630464401145856",
    "taskOwnerName": "桃桃（杨婕）",
    "taskStatus": "COMPLETED",
    "sortNo": 16,
    "comment": "https://smmqalicrx.feishu.cn/docx/PHNiddNhOo85SfxlPhGc3lhonWe",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [
      {
        "id": "522613123392208897",
        "taskId": "522613122591096843",
        "taskCode": "TASK-20250409000806",
        "taskName": "确定供应商方案",
        "preRelateType": "FS"
      }
    ],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096841",
    "taskCode": "TASK-20250409000804",
    "taskName": "合规备案",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "product_line",
    "bizLineName": "产品开发线",
    "bizStage": "03",
    "bizStageName": "放大验证",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-10-30T16:00:00.000+00:00",
    "planEndTime": "2025-01-25T16:00:00.000+00:00",
    "planWorkDay": 180,
    "realStartTime": "2024-10-31T00:00:00.000+00:00",
    "realEndTime": "2025-01-26T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630464401145856",
    "taskOwnerName": "桃桃（杨婕）",
    "taskStatus": "COMPLETED",
    "sortNo": 13,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [
      {
        "id": "522613123388014595",
        "taskId": "522613122591096840",
        "taskCode": "TASK-20250409000803",
        "taskName": "灌装中试",
        "preRelateType": "FS"
      }
    ],
    "executors": [],
    "followers": [],
    "children": [
      {
        "id": "524693549711622144",
        "taskCode": "TASK-20250415000001",
        "taskName": "合规备案&特证",
        "description": null,
        "taskType": "NORMAL",
        "bizLine": "product_line",
        "bizLineName": "产品开发线",
        "bizStage": "03",
        "bizStageName": "放大验证",
        "keyTask": false,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": false,
        "planStartTime": "2024-10-30T16:00:00.000+00:00",
        "planEndTime": "2024-12-08T16:00:00.000+00:00",
        "planWorkDay": 40,
        "realStartTime": "2024-04-26T00:00:00.000+00:00",
        "realEndTime": "2024-12-05T00:00:00.000+00:00",
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630570835804160",
        "taskOwnerName": "非鹿（汤丽燕）",
        "taskStatus": "COMPLETED",
        "sortNo": 0,
        "comment": "高倍防晒有色粉饼完成注册申请",
        "color": "",
        "createdTime": "2025-04-15T03:30:01.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122591096841",
        "parentTaskName": "合规备案"
      }
    ],
    "childNum": 1,
    "childFinNum": 1,
    "allChildNum": 1,
    "allChildFinNum": 1,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "525514392243011591",
    "taskCode": "TASK-20250409001292",
    "taskName": "灌包兼容性测试",
    "description": "交付内容：1、兼容性测试",
    "taskType": "NORMAL",
    "bizLine": "product_line",
    "bizLineName": "产品开发线",
    "bizStage": "03",
    "bizStageName": "放大验证",
    "keyTask": false,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": false,
    "planStartTime": "2024-10-31T16:00:00.000+00:00",
    "planEndTime": "2024-11-03T16:00:00.000+00:00",
    "planWorkDay": 4,
    "realStartTime": "2024-11-01T00:00:00.000+00:00",
    "realEndTime": "2024-11-04T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630840726683648",
    "taskOwnerName": "小丸子（丛爽）",
    "taskStatus": "COMPLETED",
    "sortNo": 17,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [
      {
        "id": "525514392243011591",
        "taskId": "522613122591096840",
        "taskCode": "TASK-20250409000803",
        "taskName": "灌装中试",
        "preRelateType": "FS"
      }
    ],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591097009",
    "taskCode": "TASK-20250409001281",
    "taskName": "TR3",
    "description": null,
    "taskType": "TR",
    "bizLine": "product_line",
    "bizLineName": "产品开发线",
    "bizStage": "03",
    "bizStageName": "放大验证",
    "keyTask": false,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": false,
    "planStartTime": "2024-10-31T16:00:00.000+00:00",
    "planEndTime": "2024-10-31T16:00:00.000+00:00",
    "planWorkDay": 1,
    "realStartTime": "2025-04-29T00:00:00.000+00:00",
    "realEndTime": "2025-04-29T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630812515794944",
    "taskOwnerName": "元素（彭绍远）",
    "taskStatus": "COMPLETED",
    "sortNo": 15,
    "comment": "经技术委员会评估看进行大货生产",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [
      {
        "id": "524776353954791437",
        "taskId": "522613122591096838",
        "taskCode": "TASK-20250409000801",
        "taskName": "配方生产验证",
        "preRelateType": "FS"
      },
      {
        "id": "524776353954791438",
        "taskId": "522613122591096839",
        "taskCode": "TASK-20250409000802",
        "taskName": "中试包材生产验证",
        "preRelateType": "FS"
      },
      {
        "id": "524776353954791439",
        "taskId": "522613122591096840",
        "taskCode": "TASK-20250409000803",
        "taskName": "灌装中试",
        "preRelateType": "FS"
      }
    ],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096842",
    "taskCode": "TASK-20250409000805",
    "taskName": "锁定供应商方案",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "product_line",
    "bizLineName": "产品开发线",
    "bizStage": "03",
    "bizStageName": "放大验证",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-10-31T16:00:00.000+00:00",
    "planEndTime": "2024-11-01T16:00:00.000+00:00",
    "planWorkDay": 15,
    "realStartTime": "2024-11-01T00:00:00.000+00:00",
    "realEndTime": "2024-11-02T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630688100155392",
    "taskOwnerName": "剑峰（颜剑峰）",
    "taskStatus": "COMPLETED",
    "sortNo": 14,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [
      {
        "id": "522613123388014596",
        "taskId": "522613122586902531",
        "taskCode": "TASK-20250409000794",
        "taskName": "灌装小试",
        "preRelateType": "FS"
      },
      {
        "id": "522613123388014597",
        "taskId": "522613122591096841",
        "taskCode": "TASK-20250409000804",
        "taskName": "合规备案",
        "preRelateType": "FS"
      }
    ],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096845",
    "taskCode": "TASK-20250409000808",
    "taskName": "GATE3结果拟定",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "product_line",
    "bizLineName": "产品开发线",
    "bizStage": "03",
    "bizStageName": "放大验证",
    "keyTask": false,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-10-31T16:00:00.000+00:00",
    "planEndTime": "2024-11-02T16:00:00.000+00:00",
    "planWorkDay": 2,
    "realStartTime": "2024-11-01T00:00:00.000+00:00",
    "realEndTime": "2024-11-03T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630464401145856",
    "taskOwnerName": "桃桃（杨婕）",
    "taskStatus": "COMPLETED",
    "sortNo": 17,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [
      {
        "id": "522613123392208898",
        "taskId": "522613122591096844",
        "taskCode": "TASK-20250409000807",
        "taskName": "汇总GATE3材料",
        "preRelateType": "FS"
      }
    ],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591097000",
    "taskCode": "TASK-20250409001275",
    "taskName": "确定供应方案",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "product_line",
    "bizLineName": "产品开发线",
    "bizStage": "03",
    "bizStageName": "放大验证",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": false,
    "planStartTime": "2024-11-02T16:00:00.000+00:00",
    "planEndTime": "2024-11-02T16:00:00.000+00:00",
    "planWorkDay": 1,
    "realStartTime": "2024-10-30T00:00:00.000+00:00",
    "realEndTime": "2024-10-31T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630571330732032",
    "taskOwnerName": "子青（李梦娟）",
    "taskStatus": "COMPLETED",
    "sortNo": 15,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [
      {
        "id": "524776353954791425",
        "taskId": "522613122591096842",
        "taskCode": "TASK-20250409000805",
        "taskName": "锁定供应商方案",
        "preRelateType": "FS"
      }
    ],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096846",
    "taskCode": "TASK-20250409000809",
    "taskName": "GATE3评审结果决策",
    "description": null,
    "taskType": "GATE",
    "bizLine": "product_line",
    "bizLineName": "产品开发线",
    "bizStage": "03",
    "bizStageName": "放大验证",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": true,
    "milestoneNode": "GATE3",
    "controlTask": true,
    "planStartTime": "2024-11-03T16:00:00.000+00:00",
    "planEndTime": "2024-11-03T16:00:00.000+00:00",
    "planWorkDay": 1,
    "realStartTime": "2024-11-04T00:00:00.000+00:00",
    "realEndTime": null,
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630464401145856",
    "taskOwnerName": "桃桃（杨婕）",
    "taskStatus": "RUNNING",
    "sortNo": 18,
    "comment": null,
    "color": null,
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [
      {
        "id": "522613123392208899",
        "taskId": "522613122591096845",
        "taskCode": "TASK-20250409000808",
        "taskName": "GATE3结果拟定",
        "preRelateType": "FS"
      }
    ],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096869",
    "taskCode": "TASK-20250409000832",
    "taskName": "制定种子内容包",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "sales_line",
    "bizLineName": "营销线",
    "bizStage": "04",
    "bizStageName": "上市准备",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-11-03T16:00:00.000+00:00",
    "planEndTime": "2025-01-01T16:00:00.000+00:00",
    "planWorkDay": 60,
    "realStartTime": "2024-11-04T00:00:00.000+00:00",
    "realEndTime": "2024-12-31T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630133437005824",
    "taskOwnerName": "星星（陈怡欣）",
    "taskStatus": "WAIT_STAGE",
    "sortNo": 41,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096872",
    "taskCode": "TASK-20250409000835",
    "taskName": "制定渠道营销执行方案",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "sales_line",
    "bizLineName": "营销线",
    "bizStage": "04",
    "bizStageName": "上市准备",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-11-03T16:00:00.000+00:00",
    "planEndTime": "2024-11-22T16:00:00.000+00:00",
    "planWorkDay": 20,
    "realStartTime": "2024-11-04T00:00:00.000+00:00",
    "realEndTime": "2024-11-19T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630133437005824",
    "taskOwnerName": "星星（陈怡欣）",
    "taskStatus": "WAIT_STAGE",
    "sortNo": 44,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096873",
    "taskCode": "TASK-20250409000836",
    "taskName": "制定公关传播方案",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "sales_line",
    "bizLineName": "营销线",
    "bizStage": "04",
    "bizStageName": "上市准备",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-11-03T16:00:00.000+00:00",
    "planEndTime": "2024-11-17T16:00:00.000+00:00",
    "planWorkDay": 15,
    "realStartTime": "2024-11-04T00:00:00.000+00:00",
    "realEndTime": "2024-12-18T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630133437005824",
    "taskOwnerName": "星星（陈怡欣）",
    "taskStatus": "WAIT_STAGE",
    "sortNo": 45,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591097006",
    "taskCode": "TASK-20250409001278",
    "taskName": "输出首批生产条件确认单&规格书发放",
    "description": "交付内容：1、首批生产条件确认单",
    "taskType": "NORMAL",
    "bizLine": "product_line",
    "bizLineName": "产品开发线",
    "bizStage": "04",
    "bizStageName": "上市准备",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": false,
    "planStartTime": "2024-11-03T16:00:00.000+00:00",
    "planEndTime": "2024-11-03T16:00:00.000+00:00",
    "planWorkDay": 1,
    "realStartTime": null,
    "realEndTime": null,
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630812515794944",
    "taskOwnerName": "元素（彭绍远）",
    "taskStatus": "WAIT_STAGE",
    "sortNo": 15,
    "comment": null,
    "color": null,
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [
      {
        "id": "524776353954791432",
        "taskId": "522613122591096846",
        "taskCode": "TASK-20250409000809",
        "taskName": "GATE3评审结果决策",
        "preRelateType": "FS"
      }
    ],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096871",
    "taskCode": "TASK-20250409000834",
    "taskName": "制定内容营销&推广方案",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "sales_line",
    "bizLineName": "营销线",
    "bizStage": "04",
    "bizStageName": "上市准备",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-11-03T16:00:00.000+00:00",
    "planEndTime": "2024-12-02T16:00:00.000+00:00",
    "planWorkDay": 30,
    "realStartTime": "2024-11-04T00:00:00.000+00:00",
    "realEndTime": "2024-12-02T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630133437005824",
    "taskOwnerName": "星星（陈怡欣）",
    "taskStatus": "WAIT_STAGE",
    "sortNo": 43,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096847",
    "taskCode": "TASK-20250409000810",
    "taskName": "大货量产",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "product_line",
    "bizLineName": "产品开发线",
    "bizStage": "04",
    "bizStageName": "上市准备",
    "keyTask": false,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-11-04T16:00:00.000+00:00",
    "planEndTime": "2025-01-30T16:00:00.000+00:00",
    "planWorkDay": 90,
    "realStartTime": null,
    "realEndTime": null,
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630571330732032",
    "taskOwnerName": "子青（李梦娟）",
    "taskStatus": "WAIT_STAGE",
    "sortNo": 19,
    "comment": null,
    "color": null,
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [
      {
        "id": "522613123392208900",
        "taskId": "522613122591097006",
        "taskCode": "TASK-20250409001278",
        "taskName": "输出首批生产条件确认单&规格书发放",
        "preRelateType": "FS"
      }
    ],
    "executors": [],
    "followers": [],
    "children": [
      {
        "id": "524363710991433728",
        "taskCode": "TASK-20250414000001",
        "taskName": "首批订单采购下单",
        "description": null,
        "taskType": "NORMAL",
        "bizLine": "product_line",
        "bizLineName": "产品开发线",
        "bizStage": "04",
        "bizStageName": "上市准备",
        "keyTask": false,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": false,
        "planStartTime": "2024-11-03T16:00:00.000+00:00",
        "planEndTime": "2024-11-09T16:00:00.000+00:00",
        "planWorkDay": 7,
        "realStartTime": null,
        "realEndTime": null,
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630571330732032",
        "taskOwnerName": "子青（李梦娟）",
        "taskStatus": "WAIT_STAGE",
        "sortNo": 0,
        "comment": null,
        "color": null,
        "createdTime": "2025-04-14T05:39:21.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122591096847",
        "parentTaskName": "大货量产"
      },
      {
        "id": "524363710991433734",
        "taskCode": "TASK-20250414000007",
        "taskName": "锁定包材规格书",
        "description": "交付内容：1、包材规格书",
        "taskType": "NORMAL",
        "bizLine": "product_line",
        "bizLineName": "产品开发线",
        "bizStage": "04",
        "bizStageName": "上市准备",
        "keyTask": false,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": false,
        "planStartTime": "2024-11-03T16:00:00.000+00:00",
        "planEndTime": "2024-11-03T16:00:00.000+00:00",
        "planWorkDay": 1,
        "realStartTime": null,
        "realEndTime": null,
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630840726683648",
        "taskOwnerName": "小丸子（丛爽）",
        "taskStatus": "WAIT_STAGE",
        "sortNo": 4,
        "comment": null,
        "color": null,
        "createdTime": "2025-04-14T05:39:21.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122591096847",
        "parentTaskName": "大货量产"
      },
      {
        "id": "524363710991433736",
        "taskCode": "TASK-20250414000009",
        "taskName": "原料生产+检验",
        "description": null,
        "taskType": "NORMAL",
        "bizLine": "product_line",
        "bizLineName": "产品开发线",
        "bizStage": "04",
        "bizStageName": "上市准备",
        "keyTask": false,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": false,
        "planStartTime": "2024-11-10T16:00:00.000+00:00",
        "planEndTime": "2024-12-16T16:00:00.000+00:00",
        "planWorkDay": 37,
        "realStartTime": null,
        "realEndTime": null,
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630571330732032",
        "taskOwnerName": "子青（李梦娟）",
        "taskStatus": "WAIT_STAGE",
        "sortNo": 6,
        "comment": null,
        "color": null,
        "createdTime": "2025-04-14T05:39:21.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [
          {
            "id": "524364975850913792",
            "taskId": "524363710991433728",
            "taskCode": "TASK-20250414000001",
            "taskName": "首批订单采购下单",
            "preRelateType": "FS"
          }
        ],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122591096847",
        "parentTaskName": "大货量产"
      },
      {
        "id": "524364975670558720",
        "taskCode": "TASK-20250414000013",
        "taskName": "包材首批大货跟产",
        "description": null,
        "taskType": "NORMAL",
        "bizLine": "product_line",
        "bizLineName": "产品开发线",
        "bizStage": "04",
        "bizStageName": "上市准备",
        "keyTask": false,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": false,
        "planStartTime": "2024-11-10T16:00:00.000+00:00",
        "planEndTime": "2024-11-13T16:00:00.000+00:00",
        "planWorkDay": 3,
        "realStartTime": null,
        "realEndTime": null,
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630840726683648",
        "taskOwnerName": "小丸子（丛爽）",
        "taskStatus": "WAIT_STAGE",
        "sortNo": 10,
        "comment": null,
        "color": null,
        "createdTime": "2025-04-14T05:44:22.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [
          {
            "id": "524364975855108097",
            "taskId": "524363710991433737",
            "taskCode": "TASK-20250414000010",
            "taskName": "主包生产+检验",
            "preRelateType": "SS"
          }
        ],
        "executors": [
          {
            "id": "524364975754444805",
            "memberId": "515630812515794944",
            "memberName": "元素（彭绍远）",
            "memberRole": "EXECUTOR",
            "mainRole": true
          }
        ],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122591096847",
        "parentTaskName": "大货量产"
      },
      {
        "id": "524363710991433738",
        "taskCode": "TASK-20250414000011",
        "taskName": "辅包生产+检验",
        "description": null,
        "taskType": "NORMAL",
        "bizLine": "product_line",
        "bizLineName": "产品开发线",
        "bizStage": "04",
        "bizStageName": "上市准备",
        "keyTask": false,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": false,
        "planStartTime": "2024-11-10T16:00:00.000+00:00",
        "planEndTime": "2024-12-06T16:00:00.000+00:00",
        "planWorkDay": 27,
        "realStartTime": null,
        "realEndTime": null,
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630571330732032",
        "taskOwnerName": "子青（李梦娟）",
        "taskStatus": "WAIT_STAGE",
        "sortNo": 8,
        "comment": null,
        "color": null,
        "createdTime": "2025-04-14T05:39:21.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [
          {
            "id": "524364975850913794",
            "taskId": "524363710991433728",
            "taskCode": "TASK-20250414000001",
            "taskName": "首批订单采购下单",
            "preRelateType": "FS"
          }
        ],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122591096847",
        "parentTaskName": "大货量产"
      },
      {
        "id": "524363710991433737",
        "taskCode": "TASK-20250414000010",
        "taskName": "主包生产+检验",
        "description": null,
        "taskType": "NORMAL",
        "bizLine": "product_line",
        "bizLineName": "产品开发线",
        "bizStage": "04",
        "bizStageName": "上市准备",
        "keyTask": false,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": false,
        "planStartTime": "2024-11-10T16:00:00.000+00:00",
        "planEndTime": "2024-12-19T16:00:00.000+00:00",
        "planWorkDay": 40,
        "realStartTime": null,
        "realEndTime": null,
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630571330732032",
        "taskOwnerName": "子青（李梦娟）",
        "taskStatus": "WAIT_STAGE",
        "sortNo": 7,
        "comment": null,
        "color": null,
        "createdTime": "2025-04-14T05:39:21.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [
          {
            "id": "524364975850913793",
            "taskId": "524363710991433728",
            "taskCode": "TASK-20250414000001",
            "taskName": "首批订单采购下单",
            "preRelateType": "FS"
          }
        ],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122591096847",
        "parentTaskName": "大货量产"
      },
      {
        "id": "524363710991433735",
        "taskCode": "TASK-20250414000008",
        "taskName": "更新供应计划（上市准备阶段）",
        "description": null,
        "taskType": "NORMAL",
        "bizLine": "product_line",
        "bizLineName": "产品开发线",
        "bizStage": "04",
        "bizStageName": "上市准备",
        "keyTask": false,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": false,
        "planStartTime": "2024-11-10T16:00:00.000+00:00",
        "planEndTime": "2024-11-14T16:00:00.000+00:00",
        "planWorkDay": 5,
        "realStartTime": null,
        "realEndTime": null,
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630571330732032",
        "taskOwnerName": "子青（李梦娟）",
        "taskStatus": "WAIT_STAGE",
        "sortNo": 5,
        "comment": null,
        "color": null,
        "createdTime": "2025-04-14T05:39:21.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [
          {
            "id": "524364975846719488",
            "taskId": "524363710991433728",
            "taskCode": "TASK-20250414000001",
            "taskName": "首批订单采购下单",
            "preRelateType": "FS"
          }
        ],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122591096847",
        "parentTaskName": "大货量产"
      },
      {
        "id": "524363710991433739",
        "taskCode": "TASK-20250414000012",
        "taskName": "灌包",
        "description": null,
        "taskType": "NORMAL",
        "bizLine": "product_line",
        "bizLineName": "产品开发线",
        "bizStage": "04",
        "bizStageName": "上市准备",
        "keyTask": false,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": false,
        "planStartTime": "2024-12-20T16:00:00.000+00:00",
        "planEndTime": "2025-01-18T16:00:00.000+00:00",
        "planWorkDay": 30,
        "realStartTime": null,
        "realEndTime": null,
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630571330732032",
        "taskOwnerName": "子青（李梦娟）",
        "taskStatus": "WAIT_STAGE",
        "sortNo": 9,
        "comment": null,
        "color": null,
        "createdTime": "2025-04-14T05:39:21.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [
          {
            "id": "524364975850913796",
            "taskId": "524363710991433737",
            "taskCode": "TASK-20250414000010",
            "taskName": "主包生产+检验",
            "preRelateType": "FS"
          }
        ],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122591096847",
        "parentTaskName": "大货量产"
      },
      {
        "id": "524363710991433729",
        "taskCode": "TASK-20250414000002",
        "taskName": "首批跟产",
        "description": null,
        "taskType": "NORMAL",
        "bizLine": "product_line",
        "bizLineName": "产品开发线",
        "bizStage": "04",
        "bizStageName": "上市准备",
        "keyTask": false,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": false,
        "planStartTime": "2024-12-20T16:00:00.000+00:00",
        "planEndTime": "2024-12-26T16:00:00.000+00:00",
        "planWorkDay": 7,
        "realStartTime": null,
        "realEndTime": null,
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630866412601344",
        "taskOwnerName": "元恺（钱峰）",
        "taskStatus": "WAIT_STAGE",
        "sortNo": 1,
        "comment": null,
        "color": null,
        "createdTime": "2025-04-14T05:39:21.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [
          {
            "id": "524364975850913795",
            "taskId": "524363710991433739",
            "taskCode": "TASK-20250414000012",
            "taskName": "灌包",
            "preRelateType": "SS"
          }
        ],
        "executors": [
          {
            "id": "524364975746056194",
            "memberId": "515630464401145856",
            "memberName": "桃桃（杨婕）",
            "memberRole": "EXECUTOR",
            "mainRole": true
          },
          {
            "id": "524364975746056195",
            "memberId": "515630708518027264",
            "memberName": "刘也（刘凯豪）",
            "memberRole": "EXECUTOR",
            "mainRole": true
          },
          {
            "id": "524364975746056196",
            "memberId": "515630454364176384",
            "memberName": "阿冰（何冬生）",
            "memberRole": "EXECUTOR",
            "mainRole": true
          },
          {
            "id": "524364975750250496",
            "memberId": "515630840726683648",
            "memberName": "小丸子（丛爽）",
            "memberRole": "EXECUTOR",
            "mainRole": true
          }
        ],
        "followers": [],
        "children": [
          {
            "id": "524363710991433731",
            "taskCode": "TASK-20250414000004",
            "taskName": "灌包首批大货跟产",
            "description": "交付内容：1、成品首批大货验证报告",
            "taskType": "NORMAL",
            "bizLine": "product_line",
            "bizLineName": "产品开发线",
            "bizStage": "04",
            "bizStageName": "上市准备",
            "keyTask": false,
            "keyLineTask": false,
            "milestoneTask": false,
            "milestoneNode": null,
            "controlTask": false,
            "planStartTime": "2024-12-20T16:00:00.000+00:00",
            "planEndTime": "2024-12-21T16:00:00.000+00:00",
            "planWorkDay": 2,
            "realStartTime": null,
            "realEndTime": null,
            "realWorkDay": null,
            "taskProgress": null,
            "taskOwnerId": "515630866412601344",
            "taskOwnerName": "元恺（钱峰）",
            "taskStatus": "WAIT_STAGE",
            "sortNo": 1,
            "comment": null,
            "color": null,
            "createdTime": "2025-04-14T05:39:21.000+00:00",
            "projectId": "519255487028396032",
            "documentSecret": "L0",
            "oneProductOneDoc": false,
            "interfaceWithLaboratory": false,
            "spuList": [],
            "lockTasks": [],
            "preTasks": [],
            "executors": [],
            "followers": [],
            "children": [],
            "childNum": 0,
            "childFinNum": 0,
            "allChildNum": 0,
            "allChildFinNum": 0,
            "forms": null,
            "docs": null,
            "parentId": "524363710991433729",
            "parentTaskName": "首批跟产"
          },
          {
            "id": "524363710991433730",
            "taskCode": "TASK-20250414000003",
            "taskName": "配制首批大货跟产",
            "description": "交付内容：1、配制首批大货验证报告",
            "taskType": "NORMAL",
            "bizLine": "product_line",
            "bizLineName": "产品开发线",
            "bizStage": "04",
            "bizStageName": "上市准备",
            "keyTask": false,
            "keyLineTask": false,
            "milestoneTask": false,
            "milestoneNode": null,
            "controlTask": false,
            "planStartTime": "2024-12-20T16:00:00.000+00:00",
            "planEndTime": "2024-12-21T16:00:00.000+00:00",
            "planWorkDay": 2,
            "realStartTime": null,
            "realEndTime": null,
            "realWorkDay": null,
            "taskProgress": null,
            "taskOwnerId": "515630866412601344",
            "taskOwnerName": "元恺（钱峰）",
            "taskStatus": "WAIT_STAGE",
            "sortNo": 0,
            "comment": null,
            "color": null,
            "createdTime": "2025-04-14T05:39:21.000+00:00",
            "projectId": "519255487028396032",
            "documentSecret": "L0",
            "oneProductOneDoc": false,
            "interfaceWithLaboratory": false,
            "spuList": [],
            "lockTasks": [],
            "preTasks": [],
            "executors": [],
            "followers": [],
            "children": [],
            "childNum": 0,
            "childFinNum": 0,
            "allChildNum": 0,
            "allChildFinNum": 0,
            "forms": null,
            "docs": null,
            "parentId": "524363710991433729",
            "parentTaskName": "首批跟产"
          }
        ],
        "childNum": 2,
        "childFinNum": 0,
        "allChildNum": 2,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122591096847",
        "parentTaskName": "大货量产"
      },
      {
        "id": "524363710991433732",
        "taskCode": "TASK-20250414000005",
        "taskName": "首批订单跟产报告",
        "description": null,
        "taskType": "NORMAL",
        "bizLine": "product_line",
        "bizLineName": "产品开发线",
        "bizStage": "04",
        "bizStageName": "上市准备",
        "keyTask": false,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": false,
        "planStartTime": "2024-12-22T16:00:00.000+00:00",
        "planEndTime": "2024-12-23T16:00:00.000+00:00",
        "planWorkDay": 2,
        "realStartTime": null,
        "realEndTime": null,
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630812515794944",
        "taskOwnerName": "元素（彭绍远）",
        "taskStatus": "WAIT_STAGE",
        "sortNo": 2,
        "comment": null,
        "color": null,
        "createdTime": "2025-04-14T05:39:21.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [
          {
            "id": "524364975850913797",
            "taskId": "524363710991433731",
            "taskCode": "TASK-20250414000004",
            "taskName": "灌包首批大货跟产",
            "preRelateType": "FS"
          }
        ],
        "executors": [
          {
            "id": "524364975754444800",
            "memberId": "515630866412601344",
            "memberName": "元恺（钱峰）",
            "memberRole": "EXECUTOR",
            "mainRole": true
          },
          {
            "id": "524364975754444801",
            "memberId": "515630840726683648",
            "memberName": "小丸子（丛爽）",
            "memberRole": "EXECUTOR",
            "mainRole": true
          },
          {
            "id": "524364975754444802",
            "memberId": "515630109021962240",
            "memberName": "山木（严水荣）",
            "memberRole": "EXECUTOR",
            "mainRole": true
          }
        ],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122591096847",
        "parentTaskName": "大货量产"
      },
      {
        "id": "524363710991433733",
        "taskCode": "TASK-20250414000006",
        "taskName": "首批订单生产质量问题评审",
        "description": null,
        "taskType": "TR",
        "bizLine": "product_line",
        "bizLineName": "产品开发线",
        "bizStage": "04",
        "bizStageName": "上市准备",
        "keyTask": false,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": false,
        "planStartTime": "2024-12-27T16:00:00.000+00:00",
        "planEndTime": "2024-12-27T16:00:00.000+00:00",
        "planWorkDay": 1,
        "realStartTime": null,
        "realEndTime": null,
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630812515794944",
        "taskOwnerName": "元素（彭绍远）",
        "taskStatus": "WAIT_STAGE",
        "sortNo": 3,
        "comment": null,
        "color": null,
        "createdTime": "2025-04-14T05:39:21.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [
          {
            "id": "524364975855108096",
            "taskId": "524363710991433729",
            "taskCode": "TASK-20250414000002",
            "taskName": "首批跟产",
            "preRelateType": "FS"
          }
        ],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122591096847",
        "parentTaskName": "大货量产"
      },
      {
        "id": "522613122591097002",
        "taskCode": "TASK-20250409001274",
        "taskName": "输出最终产品规格书",
        "description": "交付内容：1、产品规格书",
        "taskType": "NORMAL",
        "bizLine": "product_line",
        "bizLineName": "产品开发线",
        "bizStage": "04",
        "bizStageName": "上市准备",
        "keyTask": true,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": false,
        "planStartTime": "2024-12-28T16:00:00.000+00:00",
        "planEndTime": "2024-12-28T16:00:00.000+00:00",
        "planWorkDay": 1,
        "realStartTime": null,
        "realEndTime": null,
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630812515794944",
        "taskOwnerName": "元素（彭绍远）",
        "taskStatus": "WAIT_STAGE",
        "sortNo": 15,
        "comment": null,
        "color": null,
        "createdTime": "2025-04-09T09:43:08.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122591096847",
        "parentTaskName": "大货量产"
      },
      {
        "id": "522613122591097003",
        "taskCode": "TASK-20250409001273",
        "taskName": "审核注册备案一致性审核",
        "description": null,
        "taskType": "NORMAL",
        "bizLine": "product_line",
        "bizLineName": "产品开发线",
        "bizStage": "04",
        "bizStageName": "上市准备",
        "keyTask": true,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": false,
        "planStartTime": "2024-12-28T16:00:00.000+00:00",
        "planEndTime": "2024-12-28T16:00:00.000+00:00",
        "planWorkDay": 1,
        "realStartTime": null,
        "realEndTime": null,
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630812515794944",
        "taskOwnerName": "元素（彭绍远）",
        "taskStatus": "WAIT_STAGE",
        "sortNo": 15,
        "comment": null,
        "color": null,
        "createdTime": "2025-04-09T09:43:08.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122591096847",
        "parentTaskName": "大货量产"
      }
    ],
    "childNum": 13,
    "childFinNum": 0,
    "allChildNum": 15,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096901",
    "taskCode": "TASK-20250409000864",
    "taskName": "完成渠道销售/服务准备",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "ready_line",
    "bizLineName": "上市准备线",
    "bizStage": "04",
    "bizStageName": "上市准备",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-11-22T16:00:00.000+00:00",
    "planEndTime": "2025-01-09T16:00:00.000+00:00",
    "planWorkDay": 55,
    "realStartTime": "2024-11-23T00:00:00.000+00:00",
    "realEndTime": "2025-01-10T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630743519494144",
    "taskOwnerName": "镜子（李静）",
    "taskStatus": "COMPLETED",
    "sortNo": 70,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [],
    "executors": [],
    "followers": [],
    "children": [
      {
        "id": "522613122595291139",
        "taskCode": "TASK-20250409000873",
        "taskName": "交货差异备案",
        "description": null,
        "taskType": "NORMAL",
        "bizLine": "ready_line",
        "bizLineName": "上市准备线",
        "bizStage": "04",
        "bizStageName": "上市准备",
        "keyTask": true,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": true,
        "planStartTime": "2024-11-22T16:00:00.000+00:00",
        "planEndTime": "2024-12-09T16:00:00.000+00:00",
        "planWorkDay": 30,
        "realStartTime": "2024-11-23T00:00:00.000+00:00",
        "realEndTime": "2024-12-10T00:00:00.000+00:00",
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630743519494144",
        "taskOwnerName": "镜子（李静）",
        "taskStatus": "COMPLETED",
        "sortNo": 9,
        "comment": "",
        "color": "",
        "createdTime": "2025-04-09T09:43:08.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122591096901",
        "parentTaskName": "完成渠道销售/服务准备"
      },
      {
        "id": "522613122591096905",
        "taskCode": "TASK-20250409000868",
        "taskName": "达播资源准备",
        "description": null,
        "taskType": "NORMAL",
        "bizLine": "ready_line",
        "bizLineName": "上市准备线",
        "bizStage": "04",
        "bizStageName": "上市准备",
        "keyTask": true,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": true,
        "planStartTime": "2024-11-22T16:00:00.000+00:00",
        "planEndTime": "2025-01-09T16:00:00.000+00:00",
        "planWorkDay": 60,
        "realStartTime": "2024-11-23T00:00:00.000+00:00",
        "realEndTime": "2025-01-10T00:00:00.000+00:00",
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630743519494144",
        "taskOwnerName": "镜子（李静）",
        "taskStatus": "COMPLETED",
        "sortNo": 4,
        "comment": "",
        "color": "",
        "createdTime": "2025-04-09T09:43:08.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122591096901",
        "parentTaskName": "完成渠道销售/服务准备"
      },
      {
        "id": "522613122591096904",
        "taskCode": "TASK-20250409000867",
        "taskName": "店铺自播准备",
        "description": null,
        "taskType": "NORMAL",
        "bizLine": "ready_line",
        "bizLineName": "上市准备线",
        "bizStage": "04",
        "bizStageName": "上市准备",
        "keyTask": true,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": true,
        "planStartTime": "2024-11-22T16:00:00.000+00:00",
        "planEndTime": "2025-01-09T16:00:00.000+00:00",
        "planWorkDay": 60,
        "realStartTime": "2024-11-23T00:00:00.000+00:00",
        "realEndTime": "2025-01-10T00:00:00.000+00:00",
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630743519494144",
        "taskOwnerName": "镜子（李静）",
        "taskStatus": "COMPLETED",
        "sortNo": 3,
        "comment": "",
        "color": "",
        "createdTime": "2025-04-09T09:43:08.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122591096901",
        "parentTaskName": "完成渠道销售/服务准备"
      },
      {
        "id": "522613122591096903",
        "taskCode": "TASK-20250409000866",
        "taskName": "完成渠道GWP自采",
        "description": null,
        "taskType": "NORMAL",
        "bizLine": "ready_line",
        "bizLineName": "上市准备线",
        "bizStage": "04",
        "bizStageName": "上市准备",
        "keyTask": true,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": true,
        "planStartTime": "2024-11-22T16:00:00.000+00:00",
        "planEndTime": "2025-01-09T16:00:00.000+00:00",
        "planWorkDay": 50,
        "realStartTime": "2024-11-23T00:00:00.000+00:00",
        "realEndTime": "2025-01-10T00:00:00.000+00:00",
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630743519494144",
        "taskOwnerName": "镜子（李静）",
        "taskStatus": "COMPLETED",
        "sortNo": 2,
        "comment": "",
        "color": "",
        "createdTime": "2025-04-09T09:43:08.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122591096901",
        "parentTaskName": "完成渠道销售/服务准备"
      },
      {
        "id": "522613122591096902",
        "taskCode": "TASK-20250409000865",
        "taskName": "完善电商素材准备",
        "description": null,
        "taskType": "NORMAL",
        "bizLine": "ready_line",
        "bizLineName": "上市准备线",
        "bizStage": "04",
        "bizStageName": "上市准备",
        "keyTask": true,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": true,
        "planStartTime": "2024-11-22T16:00:00.000+00:00",
        "planEndTime": "2025-01-09T16:00:00.000+00:00",
        "planWorkDay": 60,
        "realStartTime": "2024-11-23T00:00:00.000+00:00",
        "realEndTime": "2025-01-10T00:00:00.000+00:00",
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630743519494144",
        "taskOwnerName": "镜子（李静）",
        "taskStatus": "COMPLETED",
        "sortNo": 1,
        "comment": "",
        "color": "",
        "createdTime": "2025-04-09T09:43:08.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122591096901",
        "parentTaskName": "完成渠道销售/服务准备"
      },
      {
        "id": "522613122595291136",
        "taskCode": "TASK-20250409000870",
        "taskName": "站内推广准备",
        "description": null,
        "taskType": "NORMAL",
        "bizLine": "ready_line",
        "bizLineName": "上市准备线",
        "bizStage": "04",
        "bizStageName": "上市准备",
        "keyTask": true,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": true,
        "planStartTime": "2024-11-22T16:00:00.000+00:00",
        "planEndTime": "2024-12-21T16:00:00.000+00:00",
        "planWorkDay": 30,
        "realStartTime": "2024-11-23T00:00:00.000+00:00",
        "realEndTime": "2024-12-22T00:00:00.000+00:00",
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630743519494144",
        "taskOwnerName": "镜子（李静）",
        "taskStatus": "COMPLETED",
        "sortNo": 6,
        "comment": "",
        "color": "",
        "createdTime": "2025-04-09T09:43:08.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122591096901",
        "parentTaskName": "完成渠道销售/服务准备"
      },
      {
        "id": "522613122595291137",
        "taskCode": "TASK-20250409000871",
        "taskName": "渠道物料准备",
        "description": null,
        "taskType": "NORMAL",
        "bizLine": "ready_line",
        "bizLineName": "上市准备线",
        "bizStage": "04",
        "bizStageName": "上市准备",
        "keyTask": true,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": true,
        "planStartTime": "2024-11-22T16:00:00.000+00:00",
        "planEndTime": "2025-01-09T16:00:00.000+00:00",
        "planWorkDay": 60,
        "realStartTime": "2024-11-23T00:00:00.000+00:00",
        "realEndTime": "2025-01-10T00:00:00.000+00:00",
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630743519494144",
        "taskOwnerName": "镜子（李静）",
        "taskStatus": "COMPLETED",
        "sortNo": 7,
        "comment": "",
        "color": "",
        "createdTime": "2025-04-09T09:43:08.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122591096901",
        "parentTaskName": "完成渠道销售/服务准备"
      },
      {
        "id": "522613122595291138",
        "taskCode": "TASK-20250409000872",
        "taskName": "营销配置",
        "description": null,
        "taskType": "NORMAL",
        "bizLine": "ready_line",
        "bizLineName": "上市准备线",
        "bizStage": "04",
        "bizStageName": "上市准备",
        "keyTask": true,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": true,
        "planStartTime": "2024-11-22T16:00:00.000+00:00",
        "planEndTime": "2025-01-09T16:00:00.000+00:00",
        "planWorkDay": 60,
        "realStartTime": "2024-11-23T00:00:00.000+00:00",
        "realEndTime": "2025-01-10T00:00:00.000+00:00",
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630743519494144",
        "taskOwnerName": "镜子（李静）",
        "taskStatus": "COMPLETED",
        "sortNo": 8,
        "comment": "",
        "color": "",
        "createdTime": "2025-04-09T09:43:08.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122591096901",
        "parentTaskName": "完成渠道销售/服务准备"
      },
      {
        "id": "522613122595291142",
        "taskCode": "TASK-20250409000876",
        "taskName": "客服话术配置",
        "description": null,
        "taskType": "NORMAL",
        "bizLine": "ready_line",
        "bizLineName": "上市准备线",
        "bizStage": "04",
        "bizStageName": "上市准备",
        "keyTask": true,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": true,
        "planStartTime": "2024-11-22T16:00:00.000+00:00",
        "planEndTime": "2025-01-09T16:00:00.000+00:00",
        "planWorkDay": 60,
        "realStartTime": "2024-11-23T00:00:00.000+00:00",
        "realEndTime": "2025-01-10T00:00:00.000+00:00",
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630743519494144",
        "taskOwnerName": "镜子（李静）",
        "taskStatus": "COMPLETED",
        "sortNo": 12,
        "comment": "",
        "color": "",
        "createdTime": "2025-04-09T09:43:08.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122591096901",
        "parentTaskName": "完成渠道销售/服务准备"
      },
      {
        "id": "522613122591096906",
        "taskCode": "TASK-20250409000869",
        "taskName": "京东自营入仓准备",
        "description": null,
        "taskType": "NORMAL",
        "bizLine": "ready_line",
        "bizLineName": "上市准备线",
        "bizStage": "04",
        "bizStageName": "上市准备",
        "keyTask": false,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": true,
        "planStartTime": "2024-12-09T16:00:00.000+00:00",
        "planEndTime": "2025-01-07T16:00:00.000+00:00",
        "planWorkDay": 30,
        "realStartTime": "2024-12-10T00:00:00.000+00:00",
        "realEndTime": "2025-01-08T00:00:00.000+00:00",
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630743519494144",
        "taskOwnerName": "镜子（李静）",
        "taskStatus": "COMPLETED",
        "sortNo": 5,
        "comment": "",
        "color": "",
        "createdTime": "2025-04-09T09:43:08.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122591096901",
        "parentTaskName": "完成渠道销售/服务准备"
      },
      {
        "id": "522613122595291141",
        "taskCode": "TASK-20250409000875",
        "taskName": "会员准备",
        "description": null,
        "taskType": "NORMAL",
        "bizLine": "ready_line",
        "bizLineName": "上市准备线",
        "bizStage": "04",
        "bizStageName": "上市准备",
        "keyTask": true,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": true,
        "planStartTime": "2024-12-11T16:00:00.000+00:00",
        "planEndTime": "2025-01-09T16:00:00.000+00:00",
        "planWorkDay": 30,
        "realStartTime": "2024-12-12T00:00:00.000+00:00",
        "realEndTime": "2025-01-10T00:00:00.000+00:00",
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630743519494144",
        "taskOwnerName": "镜子（李静）",
        "taskStatus": "COMPLETED",
        "sortNo": 11,
        "comment": "",
        "color": "",
        "createdTime": "2025-04-09T09:43:08.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122591096901",
        "parentTaskName": "完成渠道销售/服务准备"
      },
      {
        "id": "522613122595291143",
        "taskCode": "TASK-20250409000877",
        "taskName": "新品链接评价管理",
        "description": null,
        "taskType": "NORMAL",
        "bizLine": "ready_line",
        "bizLineName": "上市准备线",
        "bizStage": "04",
        "bizStageName": "上市准备",
        "keyTask": true,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": true,
        "planStartTime": "2024-12-22T16:00:00.000+00:00",
        "planEndTime": "2025-01-09T16:00:00.000+00:00",
        "planWorkDay": 30,
        "realStartTime": "2024-12-23T00:00:00.000+00:00",
        "realEndTime": "2025-01-10T00:00:00.000+00:00",
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630743519494144",
        "taskOwnerName": "镜子（李静）",
        "taskStatus": "COMPLETED",
        "sortNo": 13,
        "comment": "",
        "color": "",
        "createdTime": "2025-04-09T09:43:08.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122591096901",
        "parentTaskName": "完成渠道销售/服务准备"
      },
      {
        "id": "522613122595291140",
        "taskCode": "TASK-20250409000874",
        "taskName": "渠道分货",
        "description": null,
        "taskType": "NORMAL",
        "bizLine": "ready_line",
        "bizLineName": "上市准备线",
        "bizStage": "04",
        "bizStageName": "上市准备",
        "keyTask": true,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": true,
        "planStartTime": "2024-12-30T16:00:00.000+00:00",
        "planEndTime": "2025-01-09T16:00:00.000+00:00",
        "planWorkDay": 20,
        "realStartTime": "2024-12-31T00:00:00.000+00:00",
        "realEndTime": "2025-01-10T00:00:00.000+00:00",
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630743519494144",
        "taskOwnerName": "镜子（李静）",
        "taskStatus": "COMPLETED",
        "sortNo": 10,
        "comment": "",
        "color": "",
        "createdTime": "2025-04-09T09:43:08.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [
          {
            "id": "522613123434151938",
            "taskId": "522613122595291139",
            "taskCode": "TASK-20250409000873",
            "taskName": "交货差异备案",
            "preRelateType": "FS"
          }
        ],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122591096901",
        "parentTaskName": "完成渠道销售/服务准备"
      }
    ],
    "childNum": 13,
    "childFinNum": 13,
    "allChildNum": 13,
    "allChildFinNum": 13,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096900",
    "taskCode": "TASK-20250409000863",
    "taskName": "GATE3评审结果决策",
    "description": null,
    "taskType": "GATE",
    "bizLine": "ready_line",
    "bizLineName": "上市准备线",
    "bizStage": "03",
    "bizStageName": "放大验证",
    "keyTask": false,
    "keyLineTask": false,
    "milestoneTask": true,
    "milestoneNode": "GATE3",
    "controlTask": true,
    "planStartTime": "2024-11-22T16:00:00.000+00:00",
    "planEndTime": "2024-11-22T16:00:00.000+00:00",
    "planWorkDay": 7,
    "realStartTime": "2024-11-23T00:00:00.000+00:00",
    "realEndTime": "2024-11-23T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630743519494144",
    "taskOwnerName": "镜子（李静）",
    "taskStatus": "COMPLETED",
    "sortNo": 69,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [
      {
        "id": "522613123425763328",
        "taskId": "522613122591096897",
        "taskCode": "TASK-20250409000860",
        "taskName": "新品上市规划",
        "preRelateType": "FS"
      },
      {
        "id": "522613123425763329",
        "taskId": "522613122591096887",
        "taskCode": "TASK-20250409000850",
        "taskName": "制定用户人群策略",
        "preRelateType": "FS"
      },
      {
        "id": "522613123425763330",
        "taskId": "522613122591096888",
        "taskCode": "TASK-20250409000851",
        "taskName": "更新4P策略/GWP方案",
        "preRelateType": "FS"
      },
      {
        "id": "522613123425763331",
        "taskId": "522613122591096889",
        "taskCode": "TASK-20250409000852",
        "taskName": "渠道销售方案制定",
        "preRelateType": "FS"
      },
      {
        "id": "522613123425763332",
        "taskId": "522613122591096890",
        "taskCode": "TASK-20250409000853",
        "taskName": "全域4P策略终审",
        "preRelateType": "FS"
      },
      {
        "id": "522613123425763333",
        "taskId": "522613122591096891",
        "taskCode": "TASK-20250409000854",
        "taskName": "会员派样货量提报",
        "preRelateType": "FS"
      },
      {
        "id": "522613123429957632",
        "taskId": "522613122591096892",
        "taskCode": "TASK-20250409000855",
        "taskName": "对客素材需求收集",
        "preRelateType": "FS"
      },
      {
        "id": "522613123429957633",
        "taskId": "522613122591096893",
        "taskCode": "TASK-20250409000856",
        "taskName": "渠道落地资源（IP）提报",
        "preRelateType": "FS"
      },
      {
        "id": "522613123429957634",
        "taskId": "522613122591096894",
        "taskCode": "TASK-20250409000857",
        "taskName": "渠道提报前3月报量",
        "preRelateType": "FS"
      },
      {
        "id": "522613123429957635",
        "taskId": "522613122591096895",
        "taskCode": "TASK-20250409000858",
        "taskName": "项目销售目标确认",
        "preRelateType": "FS"
      },
      {
        "id": "522613123429957636",
        "taskId": "522613122591096896",
        "taskCode": "TASK-20250409000859",
        "taskName": "项目明确阶段",
        "preRelateType": "FS"
      },
      {
        "id": "522613123429957637",
        "taskId": "522613122591096899",
        "taskCode": "TASK-20250409000862",
        "taskName": "商业模式确认",
        "preRelateType": "FS"
      },
      {
        "id": "522613123434151936",
        "taskId": "522613122591096898",
        "taskCode": "TASK-20250409000861",
        "taskName": "上市3个月报量确认",
        "preRelateType": "FS"
      },
      {
        "id": "522613123434151937",
        "taskId": "522613122591096899",
        "taskCode": "TASK-20250409000862",
        "taskName": "商业模式确认",
        "preRelateType": "FS"
      }
    ],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096870",
    "taskCode": "TASK-20250409000833",
    "taskName": "种子物料审核",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "sales_line",
    "bizLineName": "营销线",
    "bizStage": "04",
    "bizStageName": "上市准备",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-11-23T16:00:00.000+00:00",
    "planEndTime": "2024-11-29T16:00:00.000+00:00",
    "planWorkDay": 7,
    "realStartTime": "2024-11-24T00:00:00.000+00:00",
    "realEndTime": "2024-12-25T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630133437005824",
    "taskOwnerName": "星星（陈怡欣）",
    "taskStatus": "WAIT_STAGE",
    "sortNo": 42,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096874",
    "taskCode": "TASK-20250409000837",
    "taskName": "更新整合营销方案&预算&资源锁定&种子内",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "sales_line",
    "bizLineName": "营销线",
    "bizStage": "04",
    "bizStageName": "上市准备",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-11-30T16:00:00.000+00:00",
    "planEndTime": "2024-12-14T16:00:00.000+00:00",
    "planWorkDay": 15,
    "realStartTime": "2024-12-01T00:00:00.000+00:00",
    "realEndTime": "2024-12-11T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630133437005824",
    "taskOwnerName": "星星（陈怡欣）",
    "taskStatus": "WAIT_STAGE",
    "sortNo": 46,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096879",
    "taskCode": "TASK-20250409000842",
    "taskName": "营销物料制作&上线发布",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "sales_line",
    "bizLineName": "营销线",
    "bizStage": "04",
    "bizStageName": "上市准备",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-12-11T16:00:00.000+00:00",
    "planEndTime": "2025-02-08T16:00:00.000+00:00",
    "planWorkDay": 60,
    "realStartTime": "2024-12-01T00:00:00.000+00:00",
    "realEndTime": "2025-02-04T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630133437005824",
    "taskOwnerName": "星星（陈怡欣）",
    "taskStatus": "WAIT_STAGE",
    "sortNo": 51,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096875",
    "taskCode": "TASK-20250409000838",
    "taskName": "MR4",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "sales_line",
    "bizLineName": "营销线",
    "bizStage": "04",
    "bizStageName": "上市准备",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-12-14T16:00:00.000+00:00",
    "planEndTime": "2024-12-14T16:00:00.000+00:00",
    "planWorkDay": 1,
    "realStartTime": "2024-12-15T00:00:00.000+00:00",
    "realEndTime": "2024-12-18T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630133437005824",
    "taskOwnerName": "星星（陈怡欣）",
    "taskStatus": "WAIT_STAGE",
    "sortNo": 47,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096876",
    "taskCode": "TASK-20250409000839",
    "taskName": "组织产品推介会",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "sales_line",
    "bizLineName": "营销线",
    "bizStage": "04",
    "bizStageName": "上市准备",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-12-15T16:00:00.000+00:00",
    "planEndTime": "2024-12-21T16:00:00.000+00:00",
    "planWorkDay": 7,
    "realStartTime": "2024-12-16T00:00:00.000+00:00",
    "realEndTime": "2024-12-22T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630133437005824",
    "taskOwnerName": "星星（陈怡欣）",
    "taskStatus": "WAIT_STAGE",
    "sortNo": 48,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096877",
    "taskCode": "TASK-20250409000840",
    "taskName": "培训课件开发&讲师认证",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "sales_line",
    "bizLineName": "营销线",
    "bizStage": "04",
    "bizStageName": "上市准备",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-12-21T16:00:00.000+00:00",
    "planEndTime": "2024-12-27T16:00:00.000+00:00",
    "planWorkDay": 7,
    "realStartTime": "2024-12-22T00:00:00.000+00:00",
    "realEndTime": "2024-12-28T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630133437005824",
    "taskOwnerName": "星星（陈怡欣）",
    "taskStatus": "WAIT_STAGE",
    "sortNo": 49,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096878",
    "taskCode": "TASK-20250409000841",
    "taskName": "产品上市培训",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "sales_line",
    "bizLineName": "营销线",
    "bizStage": "04",
    "bizStageName": "上市准备",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-12-27T16:00:00.000+00:00",
    "planEndTime": "2025-01-02T16:00:00.000+00:00",
    "planWorkDay": 7,
    "realStartTime": "2024-12-28T00:00:00.000+00:00",
    "realEndTime": "2025-01-03T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630133437005824",
    "taskOwnerName": "星星（陈怡欣）",
    "taskStatus": "WAIT_STAGE",
    "sortNo": 50,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096880",
    "taskCode": "TASK-20250409000843",
    "taskName": "推广&直播&千川等内容策略审核",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "sales_line",
    "bizLineName": "营销线",
    "bizStage": "04",
    "bizStageName": "上市准备",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2024-12-31T16:00:00.000+00:00",
    "planEndTime": "2025-01-29T16:00:00.000+00:00",
    "planWorkDay": 30,
    "realStartTime": "2025-01-01T00:00:00.000+00:00",
    "realEndTime": "2025-01-30T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630133437005824",
    "taskOwnerName": "星星（陈怡欣）",
    "taskStatus": "WAIT_STAGE",
    "sortNo": 52,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122595291144",
    "taskCode": "TASK-20250409000878",
    "taskName": "上市检查",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "ready_line",
    "bizLineName": "上市准备线",
    "bizStage": "04",
    "bizStageName": "上市准备",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": true,
    "planStartTime": "2025-01-14T16:00:00.000+00:00",
    "planEndTime": "2025-02-11T16:00:00.000+00:00",
    "planWorkDay": 40,
    "realStartTime": "2025-01-15T00:00:00.000+00:00",
    "realEndTime": "2025-02-12T00:00:00.000+00:00",
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630743519494144",
    "taskOwnerName": "镜子（李静）",
    "taskStatus": "COMPLETED",
    "sortNo": 71,
    "comment": "",
    "color": "",
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [],
    "executors": [],
    "followers": [],
    "children": [
      {
        "id": "522613122595291148",
        "taskCode": "TASK-20250409000882",
        "taskName": "内容传播",
        "description": null,
        "taskType": "NORMAL",
        "bizLine": "ready_line",
        "bizLineName": "上市准备线",
        "bizStage": "04",
        "bizStageName": "上市准备",
        "keyTask": true,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": true,
        "planStartTime": "2025-01-14T16:00:00.000+00:00",
        "planEndTime": "2025-02-09T16:00:00.000+00:00",
        "planWorkDay": 30,
        "realStartTime": "2025-01-15T00:00:00.000+00:00",
        "realEndTime": "2025-02-10T00:00:00.000+00:00",
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630743519494144",
        "taskOwnerName": "镜子（李静）",
        "taskStatus": "COMPLETED",
        "sortNo": 4,
        "comment": "",
        "color": "",
        "createdTime": "2025-04-09T09:43:08.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122595291144",
        "parentTaskName": "上市检查"
      },
      {
        "id": "522613122595291145",
        "taskCode": "TASK-20250409000879",
        "taskName": "渠道素材终审",
        "description": null,
        "taskType": "NORMAL",
        "bizLine": "ready_line",
        "bizLineName": "上市准备线",
        "bizStage": "04",
        "bizStageName": "上市准备",
        "keyTask": false,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": true,
        "planStartTime": "2025-01-14T16:00:00.000+00:00",
        "planEndTime": "2025-01-23T16:00:00.000+00:00",
        "planWorkDay": 10,
        "realStartTime": "2025-01-15T00:00:00.000+00:00",
        "realEndTime": "2025-01-24T00:00:00.000+00:00",
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630743519494144",
        "taskOwnerName": "镜子（李静）",
        "taskStatus": "COMPLETED",
        "sortNo": 1,
        "comment": "",
        "color": "",
        "createdTime": "2025-04-09T09:43:08.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [
          {
            "id": "522613123434151939",
            "taskId": "522613122591096902",
            "taskCode": "TASK-20250409000865",
            "taskName": "完善电商素材准备",
            "preRelateType": "FS"
          }
        ],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122595291144",
        "parentTaskName": "上市检查"
      },
      {
        "id": "522613122595291146",
        "taskCode": "TASK-20250409000880",
        "taskName": "推广承接",
        "description": null,
        "taskType": "NORMAL",
        "bizLine": "ready_line",
        "bizLineName": "上市准备线",
        "bizStage": "04",
        "bizStageName": "上市准备",
        "keyTask": true,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": true,
        "planStartTime": "2025-01-14T16:00:00.000+00:00",
        "planEndTime": "2025-02-09T16:00:00.000+00:00",
        "planWorkDay": 30,
        "realStartTime": "2025-01-15T00:00:00.000+00:00",
        "realEndTime": "2025-02-10T00:00:00.000+00:00",
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630743519494144",
        "taskOwnerName": "镜子（李静）",
        "taskStatus": "COMPLETED",
        "sortNo": 2,
        "comment": "",
        "color": "",
        "createdTime": "2025-04-09T09:43:08.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [
          {
            "id": "522613123434151940",
            "taskId": "522613122595291136",
            "taskCode": "TASK-20250409000870",
            "taskName": "站内推广准备",
            "preRelateType": "FS"
          }
        ],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122595291144",
        "parentTaskName": "上市检查"
      },
      {
        "id": "522613122595291152",
        "taskCode": "TASK-20250409000886",
        "taskName": "直播间承接",
        "description": null,
        "taskType": "NORMAL",
        "bizLine": "ready_line",
        "bizLineName": "上市准备线",
        "bizStage": "04",
        "bizStageName": "上市准备",
        "keyTask": true,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": true,
        "planStartTime": "2025-01-14T16:00:00.000+00:00",
        "planEndTime": "2025-02-11T16:00:00.000+00:00",
        "planWorkDay": 30,
        "realStartTime": "2025-01-15T00:00:00.000+00:00",
        "realEndTime": "2025-02-12T00:00:00.000+00:00",
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630743519494144",
        "taskOwnerName": "镜子（李静）",
        "taskStatus": "COMPLETED",
        "sortNo": 8,
        "comment": "",
        "color": "",
        "createdTime": "2025-04-09T09:43:08.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [
          {
            "id": "522613123438346241",
            "taskId": "522613122591096904",
            "taskCode": "TASK-20250409000867",
            "taskName": "店铺自播准备",
            "preRelateType": "FS"
          }
        ],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122595291144",
        "parentTaskName": "上市检查"
      },
      {
        "id": "522613122595291151",
        "taskCode": "TASK-20250409000885",
        "taskName": "客服承接",
        "description": null,
        "taskType": "NORMAL",
        "bizLine": "ready_line",
        "bizLineName": "上市准备线",
        "bizStage": "04",
        "bizStageName": "上市准备",
        "keyTask": true,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": true,
        "planStartTime": "2025-01-14T16:00:00.000+00:00",
        "planEndTime": "2025-02-09T16:00:00.000+00:00",
        "planWorkDay": 30,
        "realStartTime": "2025-01-15T00:00:00.000+00:00",
        "realEndTime": "2025-02-10T00:00:00.000+00:00",
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630743519494144",
        "taskOwnerName": "镜子（李静）",
        "taskStatus": "COMPLETED",
        "sortNo": 7,
        "comment": "",
        "color": "",
        "createdTime": "2025-04-09T09:43:08.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [
          {
            "id": "522613123438346240",
            "taskId": "522613122595291142",
            "taskCode": "TASK-20250409000876",
            "taskName": "客服话术配置",
            "preRelateType": "FS"
          }
        ],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122595291144",
        "parentTaskName": "上市检查"
      },
      {
        "id": "522613122595291150",
        "taskCode": "TASK-20250409000884",
        "taskName": "库存排查",
        "description": null,
        "taskType": "NORMAL",
        "bizLine": "ready_line",
        "bizLineName": "上市准备线",
        "bizStage": "04",
        "bizStageName": "上市准备",
        "keyTask": true,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": true,
        "planStartTime": "2025-01-21T16:00:00.000+00:00",
        "planEndTime": "2025-02-09T16:00:00.000+00:00",
        "planWorkDay": 20,
        "realStartTime": "2025-01-22T00:00:00.000+00:00",
        "realEndTime": "2025-02-10T00:00:00.000+00:00",
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630743519494144",
        "taskOwnerName": "镜子（李静）",
        "taskStatus": "COMPLETED",
        "sortNo": 6,
        "comment": "",
        "color": "",
        "createdTime": "2025-04-09T09:43:08.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [
          {
            "id": "522613123434151942",
            "taskId": "522613122595291139",
            "taskCode": "TASK-20250409000873",
            "taskName": "交货差异备案",
            "preRelateType": "FS"
          }
        ],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122595291144",
        "parentTaskName": "上市检查"
      },
      {
        "id": "522613122595291147",
        "taskCode": "TASK-20250409000881",
        "taskName": "页面素材装修检查",
        "description": null,
        "taskType": "NORMAL",
        "bizLine": "ready_line",
        "bizLineName": "上市准备线",
        "bizStage": "04",
        "bizStageName": "上市准备",
        "keyTask": true,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": true,
        "planStartTime": "2025-02-04T16:00:00.000+00:00",
        "planEndTime": "2025-02-11T16:00:00.000+00:00",
        "planWorkDay": 90,
        "realStartTime": "2025-02-05T00:00:00.000+00:00",
        "realEndTime": "2025-02-12T00:00:00.000+00:00",
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630743519494144",
        "taskOwnerName": "镜子（李静）",
        "taskStatus": "COMPLETED",
        "sortNo": 3,
        "comment": "",
        "color": "",
        "createdTime": "2025-04-09T09:43:08.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122595291144",
        "parentTaskName": "上市检查"
      },
      {
        "id": "522613122595291149",
        "taskCode": "TASK-20250409000883",
        "taskName": "检查营销资源配置",
        "description": null,
        "taskType": "NORMAL",
        "bizLine": "ready_line",
        "bizLineName": "上市准备线",
        "bizStage": "04",
        "bizStageName": "上市准备",
        "keyTask": true,
        "keyLineTask": false,
        "milestoneTask": false,
        "milestoneNode": null,
        "controlTask": true,
        "planStartTime": "2025-02-04T16:00:00.000+00:00",
        "planEndTime": "2025-02-11T16:00:00.000+00:00",
        "planWorkDay": 10,
        "realStartTime": "2025-02-05T00:00:00.000+00:00",
        "realEndTime": "2025-02-12T00:00:00.000+00:00",
        "realWorkDay": null,
        "taskProgress": null,
        "taskOwnerId": "515630743519494144",
        "taskOwnerName": "镜子（李静）",
        "taskStatus": "COMPLETED",
        "sortNo": 5,
        "comment": "",
        "color": "",
        "createdTime": "2025-04-09T09:43:08.000+00:00",
        "projectId": "519255487028396032",
        "documentSecret": "L0",
        "oneProductOneDoc": false,
        "interfaceWithLaboratory": false,
        "spuList": [],
        "lockTasks": [],
        "preTasks": [
          {
            "id": "522613123434151941",
            "taskId": "522613122595291138",
            "taskCode": "TASK-20250409000872",
            "taskName": "营销配置",
            "preRelateType": "FS"
          }
        ],
        "executors": [],
        "followers": [],
        "children": [],
        "childNum": 0,
        "childFinNum": 0,
        "allChildNum": 0,
        "allChildFinNum": 0,
        "forms": null,
        "docs": null,
        "parentId": "522613122595291144",
        "parentTaskName": "上市检查"
      }
    ],
    "childNum": 8,
    "childFinNum": 8,
    "allChildNum": 8,
    "allChildFinNum": 8,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096848",
    "taskCode": "TASK-20250409000811",
    "taskName": "大货分仓入库",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "product_line",
    "bizLineName": "产品开发线",
    "bizStage": "04",
    "bizStageName": "上市准备",
    "keyTask": false,
    "keyLineTask": false,
    "milestoneTask": true,
    "milestoneNode": "INSTOCK",
    "controlTask": true,
    "planStartTime": "2025-01-30T16:00:00.000+00:00",
    "planEndTime": "2025-02-05T16:00:00.000+00:00",
    "planWorkDay": 7,
    "realStartTime": null,
    "realEndTime": null,
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630571330732032",
    "taskOwnerName": "子青（李梦娟）",
    "taskStatus": "WAIT_STAGE",
    "sortNo": 20,
    "comment": null,
    "color": null,
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [
      {
        "id": "522613123396403200",
        "taskId": "522613122591096847",
        "taskCode": "TASK-20250409000810",
        "taskName": "大货量产",
        "preRelateType": "FS"
      }
    ],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591097004",
    "taskCode": "TASK-20250409001276",
    "taskName": "输出质量客诉预案",
    "description": "交付内容：1、质量客诉预案",
    "taskType": "NORMAL",
    "bizLine": "product_line",
    "bizLineName": "产品开发线",
    "bizStage": "04",
    "bizStageName": "上市准备",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": false,
    "planStartTime": "2025-02-06T16:00:00.000+00:00",
    "planEndTime": "2025-02-06T16:00:00.000+00:00",
    "planWorkDay": 1,
    "realStartTime": null,
    "realEndTime": null,
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630812515794944",
    "taskOwnerName": "元素（彭绍远）",
    "taskStatus": "WAIT_STAGE",
    "sortNo": 15,
    "comment": null,
    "color": null,
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [
      {
        "id": "524776353954791430",
        "taskId": "522613122591096848",
        "taskCode": "TASK-20250409000811",
        "taskName": "大货分仓入库",
        "preRelateType": "FS"
      }
    ],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591097010",
    "taskCode": "TASK-20250409001280",
    "taskName": "TR4",
    "description": null,
    "taskType": "TR",
    "bizLine": "product_line",
    "bizLineName": "产品开发线",
    "bizStage": "04",
    "bizStageName": "上市准备",
    "keyTask": false,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": false,
    "planStartTime": "2025-02-06T16:00:00.000+00:00",
    "planEndTime": "2025-02-06T16:00:00.000+00:00",
    "planWorkDay": 1,
    "realStartTime": null,
    "realEndTime": null,
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630812515794944",
    "taskOwnerName": "元素（彭绍远）",
    "taskStatus": "WAIT_STAGE",
    "sortNo": 15,
    "comment": null,
    "color": null,
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [
      {
        "id": "524776353954791440",
        "taskId": "522613122591096847",
        "taskCode": "TASK-20250409000810",
        "taskName": "大货量产",
        "preRelateType": "FS"
      },
      {
        "id": "524776353954791441",
        "taskId": "522613122591096848",
        "taskCode": "TASK-20250409000811",
        "taskName": "大货分仓入库",
        "preRelateType": "FS"
      }
    ],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591097007",
    "taskCode": "TASK-20250409001279",
    "taskName": "补充风险库，问题库",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "product_line",
    "bizLineName": "产品开发线",
    "bizStage": "04",
    "bizStageName": "上市准备",
    "keyTask": false,
    "keyLineTask": false,
    "milestoneTask": false,
    "milestoneNode": null,
    "controlTask": false,
    "planStartTime": "2025-02-07T16:00:00.000+00:00",
    "planEndTime": "2025-02-07T16:00:00.000+00:00",
    "planWorkDay": 1,
    "realStartTime": null,
    "realEndTime": null,
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630812515794944",
    "taskOwnerName": "元素（彭绍远）",
    "taskStatus": "WAIT_STAGE",
    "sortNo": 15,
    "comment": null,
    "color": null,
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [
      {
        "id": "524776353954791433",
        "taskId": "522613122591097010",
        "taskCode": "TASK-20250409001280",
        "taskName": "TR4",
        "preRelateType": "FS"
      }
    ],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  },
  {
    "id": "522613122591096849",
    "taskCode": "TASK-20250409000812",
    "taskName": "上市决策",
    "description": null,
    "taskType": "NORMAL",
    "bizLine": "product_line",
    "bizLineName": "产品开发线",
    "bizStage": "04",
    "bizStageName": "上市准备",
    "keyTask": true,
    "keyLineTask": false,
    "milestoneTask": true,
    "milestoneNode": "MARKET",
    "controlTask": true,
    "planStartTime": "2025-02-11T16:00:00.000+00:00",
    "planEndTime": "2025-02-11T16:00:00.000+00:00",
    "planWorkDay": 1,
    "realStartTime": null,
    "realEndTime": null,
    "realWorkDay": null,
    "taskProgress": null,
    "taskOwnerId": "515630464401145856",
    "taskOwnerName": "桃桃（杨婕）",
    "taskStatus": "WAIT_STAGE",
    "sortNo": 21,
    "comment": null,
    "color": null,
    "createdTime": "2025-04-09T09:43:08.000+00:00",
    "projectId": "519255487028396032",
    "documentSecret": "L0",
    "oneProductOneDoc": false,
    "interfaceWithLaboratory": false,
    "spuList": [],
    "lockTasks": [],
    "preTasks": [
      {
        "id": "522613123396403201",
        "taskId": "522613122591096847",
        "taskCode": "TASK-20250409000810",
        "taskName": "大货量产",
        "preRelateType": "FS"
      },
      {
        "id": "522613123396403202",
        "taskId": "522613122591096848",
        "taskCode": "TASK-20250409000811",
        "taskName": "大货分仓入库",
        "preRelateType": "FS"
      }
    ],
    "executors": [],
    "followers": [],
    "children": [],
    "childNum": 0,
    "childFinNum": 0,
    "allChildNum": 0,
    "allChildFinNum": 0,
    "forms": null,
    "docs": null,
    "parentId": "0",
    "parentTaskName": null
  }
]